import React, {Component} from 'react';
import Styles from './style.css';
import HeaderSignupOne from "../../components/header-signup-one/component";
import {BeatLoader} from 'react-spinners';
import cx from "classnames";
import {cartRegister} from "../../services/cartRegister";
import {dataRegister} from "../../services/dataRegister";
import {langRegister} from "../../services/langRegister";
import ReactGA from 'react-ga';
import ReactGA4 from 'react-ga4';
import ReactPixel from "react-facebook-pixel";
import {salesChannelRegister} from "../../services/salesChannelRegister";
import ErrorHandler from "../../components/error-handler/component";
import {imagesRegister} from "../../services/imagesRegister";
import {quotesRegister} from "../../services/quotesRegister";
import Information from "../../components/information/component";
import BoosterHeader from "../../components/booster-header/component";
import Slider from "rc-slider";
import {scraperRegister} from "../../services/scraperRegister";
import {industriesRegister} from "../../services/industriesRegister";
import Tooltip from "rc-tooltip";
import queryString from "query-string";
import {ratesRegister} from "../../services/ratesRegister";
import {currencyRegister} from "../../services/currencyRegister";
import {carouselRegister} from "../../services/carouselRegister";
import {videoRegister} from "../../services/videoRegister";
import {userRegister} from "../../services/userRegister";
import {tokenRegister} from "../../services/tokenRegister";

const Handle = Slider.Handle;

class BoosterIndustry extends Component {

    constructor(props) {
        super(props);
        this.state = {
            isLoading: true,
            error: false,
            industries: [],
            regions: [],
            tabs: {},
            dropdowns: {},
            sliders: {},
            amenities: {},
            scraper_data: {},
            region_grid: {},
            autocomplete_search: "",
            autocomplete_predictions: [],
            display_region: null,
            country_region: {},
            inhouse: false
        };
        this.google = window.google;
        this.update.regions = this.update.regions.bind(this);
    };

    componentWillMount() {
        window.scrollTo(0, 0);

        //GOOGLE ANALYTICS
        if (dataRegister.api.primehit !== "https://api.devprimehit.com/v1") {
            ReactGA.pageview('/booster/industry');
        }

        //FACEBOOK PIXEL
        if(dataRegister.api.primehit !== "https://api.devprimehit.com/v1"){
            ReactPixel.pageView();
        }
    };

    componentDidMount(){
        try {
            this.autocomplete = new this.google.maps.places.AutocompleteService();
        } catch (e) {}
        try {
            this.geocoder = new this.google.maps.Geocoder;
        } catch (e) {}

        carouselRegister.remove();
        videoRegister.remove();
        this.update.industries();
        this.update.user();

        let token = tokenRegister.getToken();
        if(!token){
            this.props.history.push("/" + salesChannelRegister.get('market') + "/" + langRegister.lang());
        }

    }

    update = {
        user: () => {
            let user = userRegister.get();
            if(user){
                this.setState({
                    reseller: user.reseller,
                    inhouse: user.inhouse
                }, () => {});
            }
        },
        industries: () => {
            let stored_industries = industriesRegister.get();
            try {
                if (stored_industries && stored_industries.length > 0) {
                    this.parsers.industries(stored_industries);
                } else {
                    dataRegister.getIndustries(salesChannelRegister.get("market"), langRegister.lang()).then((response) => {
                        this.parsers.industries(response);
                    }, (error) => {
                        this.props.history.push('/login');
                        //this.setState({isLoading: false, error: true});
                    });
                }
            } catch (e) {
                dataRegister.getIndustries(salesChannelRegister.get("market"), langRegister.lang()).then((response) => {
                    this.parsers.industries(response);
                }, (error) => {
                    this.props.history.push('/login');
                    //this.setState({isLoading: false, error: true});
                });
            }
        },
        regions() {
            dataRegister.getRegions(salesChannelRegister.get("market")).then((response) => {
                try {
                    let scraped_data = JSON.parse(scraperRegister.get());
                    if (scraped_data.region_grid) {
                        this.state.region_grid = scraped_data.region_grid;
                    }
                } catch (e) {
                    console.log(e)
                }
                try {
                    this.setState({
                        regions: response.regions,
                        region_grid: this.state.region_grid ? this.state.region_grid : {},
                        country_region: JSON.parse(salesChannelRegister.get("country_region")) ? JSON.parse(salesChannelRegister.get("country_region")) : {}
                    }, () => {
                        console.log(this.state.country_region);
                        this.parsers.regions(this.state.regions, 1);
                    });
                } catch (e) {
                    console.log(e);
                }
            }, (error) => {
            });
        },
        currencies: (base, value) => {
            dataRegister.rates(base).then((response) => {
                try {
                    let currencies = [];
                    let currency = null;
                    for(let key in response.rates){
                        currencies.push({title: key, rate: response.rates[key]});
                        try {
                            if(key.toLowerCase() === value.toLowerCase()){
                                currency = {title: key, rate: response.rates[key]};
                            }
                        }catch (e) {}
                        if(key.toLowerCase() === base.toLowerCase() && !value){
                            currency = {title: key, rate: response.rates[key]};
                        }
                    }
                    for (let key in this.state.dropdowns) {
                        if (this.state.dropdowns[key].id === "currency") {
                            this.state.dropdowns[key].selections = currencies;
                            if(currency){
                                this.functions.setDropdown(key, JSON.stringify(currency));
                            }
                        }
                    }
                    this.setState({sliders: this.state.sliders, currencies_data: response.rates}, () => {
                        ratesRegister.set(response.rates);
                    });
                }catch (e) {}
            }, (error) => {});
        },
        scraperData: () => {
            let data = JSON.parse(scraperRegister.get());
            if (data) {

                console.log(data);

                this.setState({scraper_data: data}, () => {


                    //TABS
                    try {
                        if (this.state.scraper_data.additional_information.facts.listing_type) {
                            this.parsers.tabs(this.state.scraper_data.additional_information.facts.listing_type);
                        }
                    } catch (e) {
                        console.log(e);
                    }

                    //IDENTIFIER
                    try {
                        if (this.state.scraper_data.additional_information.facts.identifier) {
                            this.parsers.identifier(this.state.scraper_data.additional_information.facts.identifier);
                        }
                    } catch (e) {
                        console.log(e);
                    }

                    //TYPE
                    try {
                        if (this.state.scraper_data.additional_information.facts.type) {
                            this.parsers.type(this.state.scraper_data.additional_information.facts.type);
                        }
                    } catch (e) {
                        console.log(e);
                    }

                    //BEDS
                    try {
                        if (this.state.scraper_data.additional_information.facts.bedrooms !== null) {
                            this.parsers.beds(this.state.scraper_data.additional_information.facts.bedrooms);
                        }
                    } catch (e) {
                        console.log(e);
                    }

                    //BATHS
                    try {
                        if (this.state.scraper_data.additional_information.facts.bathrooms) {
                            this.parsers.baths(this.state.scraper_data.additional_information.facts.bathrooms);
                        }
                    } catch (e) {
                        console.log(e);
                    }

                    //COMPLETION STATUS
                    try {
                        if (this.state.scraper_data.additional_information.facts.completion_status) {
                            this.parsers.completionStatus(this.state.scraper_data.additional_information.facts.completion_status);
                        }
                    } catch (e) {
                        console.log(e);
                    }

                    //FURNISHINGS
                    try {
                        if (this.state.scraper_data.additional_information.facts.furnishings) {
                            this.parsers.furnishings(this.state.scraper_data.additional_information.facts.furnishings);
                        }
                    } catch (e) {
                        console.log(e);
                    }

                    //SIZE
                    try {
                        if (this.state.scraper_data.additional_information.facts.area_sqft) {
                            this.parsers.size(this.state.scraper_data.additional_information.facts.area_sqft);
                        }
                    } catch (e) {
                        console.log(e);
                    }

                    //ADDRESS
                    try {
                        if (this.state.scraper_data.additional_information.facts.places) {
                            this.parsers.place();
                        }else{
                            this.parsers.place();
                        }
                    } catch (e) {
                        console.log(e);
                    }
                    /*
                    try {
                        if(this.state.scraper_data.additional_information.facts.address_id){
                            this.setState({
                                autocomplete_lat: this.state.scraper_data.additional_information.facts.address_lat,
                                autocomplete_lng: this.state.scraper_data.additional_information.facts.address_lng,
                                autocomplete_placeid: this.state.scraper_data.additional_information.facts.address_id,
                                autocomplete_address: this.state.scraper_data.additional_information.facts.address,
                                autocomplete_full_address: this.state.scraper_data.additional_information.facts.address_full,
                                autocomplete_search: this.state.scraper_data.additional_information.facts.address
                            }, () => {

                                //PLACE
                                try {
                                    if (this.state.scraper_data.additional_information.facts.places) {
                                        this.parsers.place();
                                    }
                                } catch (e) {
                                    console.log(e);
                                }

                            });
                        }else{

                            //PLACE
                            try {
                                if (this.state.scraper_data.additional_information.facts.places) {
                                    this.parsers.place();
                                }
                            } catch (e) {
                                console.log(e);
                            }

                        }
                    } catch (e) {

                        //PLACE
                        try {
                            if (this.state.scraper_data.additional_information.facts.places) {
                                this.parsers.place();
                            }
                        } catch (e) {
                            console.log(e);
                        }

                    }
                    */

                    //CURRENCY
                    try {
                        this.parsers.currency(salesChannelRegister.get('currency'));
                    }catch (e) {

                    }

                    try {
                        if(!this.state.scraper_data.additional_information.facts.currency){

                            this.update.currencies(salesChannelRegister.get('currency'), salesChannelRegister.get('currency'));

                        }else{

                            //SET MARKET CURRENCY AS BASE
                            this.update.currencies(salesChannelRegister.get('currency'), this.state.scraper_data.additional_information.facts.currency);

                            //PRICE
                            try {
                                if (!this.state.scraper_data.additional_information.facts.base_price) {
                                    this.parsers.price(this.state.scraper_data.additional_information.facts.price);
                                }else{
                                    this.parsers.price(Math.round(this.state.scraper_data.additional_information.facts.base_price));
                                }
                            } catch (e) {
                                console.log(e);
                            }

                        }
                    } catch (e) {
                        console.log(e);
                        this.update.currencies(salesChannelRegister.get('currency'), salesChannelRegister.get('currency'));
                    }

                    //DURATION
                    try {
                        if (this.state.scraper_data.additional_information.facts.duration) {
                            this.parsers.duration(this.state.scraper_data.additional_information.facts.duration);
                        }
                    } catch (e) {
                        console.log(e);
                    }

                    //AMENITIES
                    try {
                        if (this.state.scraper_data.slogans.length > 0) {
                            this.parsers.amenities(this.state.scraper_data.slogans);
                        }
                    } catch (e) {
                        console.log(e);
                    }

                    //EXTRA -> DISCOUNT
                    try {
                        if (this.state.scraper_data.additional_information.facts.discount) {
                            this.parsers.discounts(this.state.scraper_data.additional_information.facts.discount);
                        }
                    } catch (e) {
                        console.log(e);
                    }

                    //EXTRA -> DLD WAIVER
                    try {
                        if (this.state.scraper_data.additional_information.facts.dldwaiver) {
                            this.parsers.dldwaivers(this.state.scraper_data.additional_information.facts.dldwaiver);
                        }
                    } catch (e) {
                        console.log(e);
                    }

                    //EXTRA -> DOWN PAYMENT
                    try {
                        if (this.state.scraper_data.additional_information.facts.downpayment) {
                            this.parsers.downpayments(this.state.scraper_data.additional_information.facts.downpayment);
                        }
                    } catch (e) {
                        console.log(e);
                    }

                    //EXTRA -> FINANCE
                    try {
                        if (this.state.scraper_data.additional_information.facts.finance) {
                            this.parsers.finance(this.state.scraper_data.additional_information.facts.finance);
                        }
                    } catch (e) {
                        console.log(e);
                    }

                    //EXTRA -> PAYMENT PLAN
                    try {
                        if (this.state.scraper_data.additional_information.facts.paymentplan) {
                            this.parsers.paymentplans(this.state.scraper_data.additional_information.facts.paymentplan);
                        }
                    } catch (e) {
                        console.log(e);
                    }

                    //EXTRA -> SERVICE CHARGE
                    try {
                        if (this.state.scraper_data.additional_information.facts.servicecharge) {
                            this.parsers.servicecharges(this.state.scraper_data.additional_information.facts.servicecharge);
                        }
                    } catch (e) {
                        console.log(e);
                    }

                    //EXTRA -> CHEQUES
                    try {
                        if (this.state.scraper_data.additional_information.facts.cheques) {
                            this.parsers.cheques(this.state.scraper_data.additional_information.facts.cheques);
                        }
                    } catch (e) {
                        console.log(e);
                    }

                    //EXTRA -> FREE MONTHS
                    try {
                        if (this.state.scraper_data.additional_information.facts.freemonths) {
                            this.parsers.freemonths(this.state.scraper_data.additional_information.facts.freemonths);
                        }
                    } catch (e) {
                        console.log(e);
                    }

                    //EXTRA -> ROI
                    try {
                        if (this.state.scraper_data.additional_information.facts.roi) {
                            this.parsers.roi(this.state.scraper_data.additional_information.facts.roi);
                        }
                    } catch (e) {
                        console.log(e);
                    }

                    //CHECK CROSSROAD
                    let query = queryString.parse(this.props.location.search);
                    if (query.crossroad === 'auto') {
                        setTimeout(() => {
                            this.functions.setIndustry(true);
                        }, 1000);
                    } else {
                        this.setState({isLoading: false});
                    }

                });
            }else{

            }
        },
        data: () => {
            let tabs = {
                "sell": {
                    id: 0,
                    selected: true,
                    title: this.renders.text("item_10"),
                    indentifier: "sale"
                },
                "rent": {
                    id: 1,
                    selected: false,
                    title: this.renders.text("item_11"),
                    indentifier: "rent"
                }
            };
            let dropdowns = {
                "currency": {
                    id: "currency",
                    tab_value: "rent",
                    currency: true,
                    selections: [],
                    title: this.renders.text("item_11"),
                    value: "-1"
                },
                "currency_two": {
                    id: "currency",
                    tab_value: "sell",
                    currency: true,
                    selections: [],
                    title: this.renders.text("item_11"),
                    value: "-1"
                },
                "identifier": {
                    id: "identifier",
                    tab_value: "sell",
                    selections: [
                        {id: 0, title: "Commercial"},
                        {id: 1, title: "Residential"},
                    ],
                    title: this.renders.text("item_13"),
                    value: JSON.stringify({id: 1, title: "Residential"}),
                    disabled: true
                },
                "identifier_two": {
                    id: "identifier",
                    tab_value: "rent",
                    selections: [
                        {id: 0, title: "Commercial"},
                        {id: 1, title: "Residential"},
                    ],
                    title: "Identifier",
                    value: JSON.stringify({id: 1, title: "Residential"}),
                    disabled: true
                },
                "type": {
                    id: "type",
                    tab_value: "sell",
                    selections: [
                        {id: 1, title: "Apartment"},
                        {id: 2, title: "Villa"},
                        {id: 3, title: "Townhouse"},
                        {id: 4, title: "Penthouse"},
                        {id: 5, title: "Duplex"},
                        {id: 6, title: "Bungalow"},
                        //{id: 7, title: "Land"},
                        //{id: 8, title: "Commercial"},
                        //{id: 9, title: "Full Floor"},
                        //{id: 10, title: "Half Floor"},
                        //{id: 11, title: "Bulk Unit"},
                        //{id: 12, title: "Whole Building"},
                        {id: 13, title: "Hotel Apartment"},
                        //{id: 14, title: "Compound"}
                    ],
                    title: "Type",
                    value: "-1"
                },
                "type_two": {
                    id: "type",
                    tab_value: "rent",
                    selections: [
                        {id: 1, title: "Apartment"},
                        {id: 2, title: "Villa"},
                        {id: 3, title: "Townhouse"},
                        {id: 4, title: "Penthouse"},
                        {id: 5, title: "Duplex"},
                        {id: 6, title: "Bungalow"},
                        //{id: 7, title: "Land"},
                        //{id: 8, title: "Commercial"},
                        //{id: 9, title: "Full Floor"},
                        //{id: 10, title: "Half Floor"},
                        //{id: 11, title: "Bulk Unit"},
                        //{id: 12, title: "Whole Building"},
                        {id: 13, title: "Hotel Apartment"},
                        //{id: 14, title: "Compound"}
                    ],
                    title: "Type",
                    value: "-1"
                },
                "beds": {
                    id: "beds",
                    tab_value: "sell",
                    selections: [
                        {id: 0, title: "Studio", amount: 0},
                        {id: 1, title: "1 Bed", amount: 1},
                        {id: 2, title: "2 Bed", amount: 2},
                        {id: 3, title: "3 Bed", amount: 3},
                        {id: 4, title: "4 Bed", amount: 4},
                        {id: 5, title: "5 Bed", amount: 5},
                        {id: 6, title: "6 Bed", amount: 6},
                        {id: 7, title: "7 Bed", amount: 7},
                        {id: 8, title: "8 Bed", amount: 8},
                        {id: 9, title: "9 Bed", amount: 9}
                    ],
                    title: "Beds",
                    value: "-1"
                },
                "beds_two": {
                    id: "beds",
                    tab_value: "rent",
                    selections: [
                        {id: 0, title: "Studio", amount: 0},
                        {id: 1, title: "1 Bed", amount: 1},
                        {id: 2, title: "2 Bed", amount: 2},
                        {id: 3, title: "3 Bed", amount: 3},
                        {id: 4, title: "4 Bed", amount: 4},
                        {id: 5, title: "5 Bed", amount: 5},
                        {id: 6, title: "6 Bed", amount: 6},
                        {id: 7, title: "7 Bed", amount: 7},
                        {id: 8, title: "8 Bed", amount: 8},
                        {id: 9, title: "9 Bed", amount: 9}
                    ],
                    title: "Beds",
                    value: "-1"
                },
                "baths": {
                    id: "baths",
                    tab_value: "sell",
                    selections: [
                        {id: 0, title: "1 Bath", amount: 1},
                        {id: 1, title: "2 Bath", amount: 2},
                        {id: 2, title: "3 Bath", amount: 3},
                        {id: 3, title: "4 Bath", amount: 4},
                        {id: 4, title: "5 Bath", amount: 5},
                        {id: 5, title: "6 Bath", amount: 6},
                        {id: 6, title: "7 Bath", amount: 7},
                        {id: 7, title: "8 Bath", amount: 8},
                        {id: 8, title: "9 Bath", amount: 9},
                        {id: 9, title: "10 Bath", amount: 10},
                        {id: 10, title: "11 Bath", amount: 11},
                        {id: 11, title: "12 Bath", amount: 12},
                        {id: 12, title: "13 Bath", amount: 13},
                        {id: 13, title: "14 Bath", amount: 14}
                    ],
                    title: "Baths",
                    value: "-1"
                },
                "baths_two": {
                    id: "baths",
                    tab_value: "rent",
                    selections: [
                        {id: 0, title: "1 Bath", amount: 1},
                        {id: 1, title: "2 Bath", amount: 2},
                        {id: 2, title: "3 Bath", amount: 3},
                        {id: 3, title: "4 Bath", amount: 4},
                        {id: 4, title: "5 Bath", amount: 5},
                        {id: 5, title: "6 Bath", amount: 6},
                        {id: 6, title: "7 Bath", amount: 7},
                        {id: 7, title: "8 Bath", amount: 8},
                        {id: 8, title: "9 Bath", amount: 9},
                        {id: 9, title: "10 Bath", amount: 10},
                        {id: 10, title: "11 Bath", amount: 11},
                        {id: 11, title: "12 Bath", amount: 12},
                        {id: 12, title: "13 Bath", amount: 13},
                        {id: 13, title: "14 Bath", amount: 14}
                    ],
                    title: "Baths",
                    value: "-1"
                },
                "status": {
                    id: "status",
                    tab_value: "sell",
                    extra_second: true,
                    selections: [
                        {id: 0, title: "Off-plan Property"},
                        {id: 1, title: "Ready Property"},
                        {id: 2, title: "Upcoming Listing"}
                    ],
                    title: "Status",
                    value: "-1"
                },
                "furniture": {
                    id: "furniture",
                    tab_value: "rent",
                    extra_second: true,
                    selections: [
                        {id: 0, title: "Furnished"},
                        {id: 1, title: "Unfurnished"},
                        {id: 2, title: "Partly Furnished"}
                    ],
                    title: "Furniture",
                    value: "-1"
                },
                "discount": {
                    id: "discount",
                    tab_value: "sell",
                    extra: true,
                    selections: [
                        {id: 0, title: "50% Off"},
                        {id: 1, title: "25% Off"},
                        {id: 2, title: "10% Off"},
                        {id: 3, title: "5% Off"}
                    ],
                    title: "Discount",
                    value: "-1"
                },
                "dldwaiver": {
                    id: "dldwaiver",
                    tab_value: "sell",
                    extra: true,
                    selections: [
                        {id: 0, title: "5% DLD Waiver"},
                        {id: 1, title: "10% DLD Waiver"},
                        {id: 2, title: "25% DLD Waiver"},
                        {id: 3, title: "50% DLD Waiver"},
                        {id: 4, title: "100% DLD Waiver"}
                    ],
                    title: "DLD Waiver",
                    value: "-1"
                },
                "downpayment": {
                    id: "downpayment",
                    tab_value: "sell",
                    extra: true,
                    selections: [
                        {id: 0, title: "1% Down Payment"},
                        {id: 1, title: "2% Down Payment"},
                        {id: 2, title: "3% Down Payment"},
                        {id: 3, title: "4% Down Payment"},
                        {id: 4, title: "5% Down Payment"},
                        {id: 5, title: "6% Down Payment"},
                        {id: 6, title: "7% Down Payment"},
                        {id: 7, title: "8% Down Payment"},
                        {id: 8, title: "9% Down Payment"},
                        {id: 9, title: "10% Down Payment"},
                        {id: 10, title: "15% Down Payment"},
                        {id: 11, title: "20% Down Payment"},
                        {id: 12, title: "25% Down Payment"},
                        {id: 13, title: "30% Down Payment"},
                        {id: 14, title: "35% Down Payment"},
                        {id: 15, title: "40% Down Payment"}
                    ],
                    title: "Down Payment",
                    value: "-1"
                },
                "finance": {
                    id: "finance",
                    tab_value: "sell",
                    extra: true,
                    selections: [
                        {id: 0, title: "85% Finance"},
                        {id: 1, title: "80% Finance"},
                        {id: 2, title: "75% Finance"},
                        {id: 3, title: "65% Finance"},
                        {id: 4, title: "60% Finance"},
                        {id: 5, title: "55% Finance"},
                        {id: 6, title: "50% Finance"},
                    ],
                    title: "Finance",
                    value: "-1"
                },
                "roi": {
                    id: "roi",
                    tab_value: "sell",
                    extra: true,
                    selections: [
                        {id: 0, title: "2% Net ROI"},
                        {id: 1, title: "3% Net ROI"},
                        {id: 2, title: "4% Net ROI"},
                        {id: 3, title: "5% Net ROI"},
                        {id: 4, title: "6% Net ROI"},
                        {id: 5, title: "7% Net ROI"},
                        {id: 6, title: "8% Net ROI"},
                        {id: 7, title: "9% Net ROI"},
                        {id: 8, title: "10% Net ROI"},
                        {id: 9, title: "11% Net ROI"},
                        {id: 10, title: "12% Net ROI"},
                        {id: 11, title: "13% Net ROI"},
                        {id: 12, title: "14% Net ROI"},
                        {id: 13, title: "15% Net ROI"},
                        {id: 14, title: "2% ROI"},
                        {id: 15, title: "3% ROI"},
                        {id: 16, title: "4% ROI"},
                        {id: 17, title: "5% ROI"},
                        {id: 18, title: "6% ROI"},
                        {id: 19, title: "7% ROI"},
                        {id: 20, title: "8% ROI"},
                        {id: 21, title: "9% ROI"},
                        {id: 22, title: "10% ROI"},
                        {id: 23, title: "11% ROI"},
                        {id: 24, title: "12% ROI"},
                        {id: 25, title: "15% ROI"},
                        {id: 26, title: "2% ROI Assured"},
                        {id: 27, title: "3% ROI Assured"},
                        {id: 28, title: "4% ROI Assured"},
                        {id: 29, title: "5% ROI Assured"},
                        {id: 30, title: "6% ROI Assured"},
                        {id: 31, title: "7% ROI Assured"},
                        {id: 32, title: "8% ROI Assured"},
                        {id: 33, title: "9% ROI Assured"},
                        {id: 34, title: "10% ROI Assured"},
                        {id: 35, title: "11% ROI Assured"},
                        {id: 36, title: "12% ROI Assured"},
                        {id: 37, title: "13% ROI Assured"},
                        {id: 38, title: "14% ROI Assured"},
                        {id: 39, title: "15% ROI Assured"},
                        {id: 40, title: "2% Yield Assured"},
                        {id: 41, title: "3% Yield Assured"},
                        {id: 42, title: "4% Yield Assured"},
                        {id: 43, title: "5% Yield Assured"},
                        {id: 44, title: "6% Yield Assured"},
                        {id: 45, title: "7% Yield Assured"},
                        {id: 46, title: "8% Yield Assured"},
                        {id: 47, title: "9% Yield Assured"},
                        {id: 48, title: "10% Yield Assured"},
                        {id: 49, title: "11% Yield Assured"},
                        {id: 50, title: "12% Yield Assured"},
                        {id: 51, title: "13% Yield Assured"},
                        {id: 52, title: "14% Yield Assured"},
                        {id: 53, title: "15% Yield Assured"},
                        {id: 54, title: "Up To 5% ROI"},
                        {id: 55, title: "Up To 10% ROI"},
                        {id: 56, title: "Up To 15% ROI"},
                        {id: 57, title: "Up To 20% ROI"},
                        {id: 58, title: "Up To 25% ROI"},
                    ],
                    title: "ROI",
                    value: "-1"
                },
                "paymentplan": {
                    id: "paymentplan",
                    tab_value: "sell",
                    extra: true,
                    selections: [
                        {id: 0, title: "Pay 75% On Completion"},
                        {id: 1, title: "Pay 50% On Completion"},
                        {id: 2, title: "Pay 25% On Completion"},
                        {id: 3, title: "Pay 1% Move In"},
                        {id: 4, title: "Pay 5% Move In"},
                        {id: 5, title: "Pay 10% Move In"},
                        {id: 6, title: "Pay 20% Move In"},
                        {id: 7, title: "Pay 30% Move In"},
                        {id: 8, title: "Pay 40% Move In"},
                        {id: 9, title: "Pay 50% Move In"},
                        {id: 10, title: "Pay 1.5% Monthly"},
                        {id: 11, title: "Pay 1% Monthly"},
                        {id: 12, title: "Pay 2% Monthly"},
                        {id: 13, title: "Pay 3% Monthly"},
                        {id: 14, title: "1% Monthly Payment Plan"},
                        {id: 15, title: "2% Monthly Payment Plan"},
                        {id: 16, title: "3% Monthly Payment Plan"},
                        {id: 17, title: "25y In-House Payment Plan"},
                        {id: 18, title: "20y In-House Payment Plan"},
                        {id: 19, title: "15y In-House Payment Plan"},
                        {id: 20, title: "10y In-House Payment Plan"},
                        {id: 21, title: "5y In-House Payment Plan"},
                        {id: 22, title: "5y Installment Plan"},
                        {id: 23, title: "10y Installment Plan"},
                        {id: 24, title: "15y Installment Plan"},
                        {id: 25, title: "20y Installment Plan"},
                        {id: 26, title: "25y Installment Plan"},
                        {id: 27, title: "Pay Over 5 Years"},
                        {id: 28, title: "Pay Over 10 Years"},
                        {id: 29, title: "Pay Over 15 Years"},
                        {id: 30, title: "Pay Over 20 Years"},
                        {id: 31, title: "Pay Over 25 Years"},
                        {id: 32, title: "2y Post Payment Plan"},
                        {id: 33, title: "3y Post Payment Plan"},
                        {id: 34, title: "4y Post Payment Plan"},
                        {id: 35, title: "5y Post Payment Plan"},
                        {id: 36, title: "6y Post Payment Plan"},
                        {id: 37, title: "7y Post Payment Plan"},
                        {id: 38, title: "8y Post Payment Plan"},
                        {id: 39, title: "9y Post Payment Plan"},
                        {id: 40, title: "10y Post Payment Plan"},
                        {id: 41, title: "15y Post Payment Plan"},
                        {id: 42, title: "20y Post Payment Plan"},
                        {id: 43, title: "25y Post Payment Plan"},
                        {id: 44, title: "2y Payment Plan"},
                        {id: 45, title: "3y Payment Plan"},
                        {id: 46, title: "4y Payment Plan"},
                        {id: 47, title: "5y Payment Plan"},
                        {id: 48, title: "6y Payment Plan"},
                        {id: 49, title: "7y Payment Plan"},
                        {id: 50, title: "8y Payment Plan"},
                        {id: 51, title: "9y Payment Plan"},
                        {id: 52, title: "10y Payment Plan"},
                        {id: 53, title: "15y Payment Plan"},
                        {id: 55, title: "20y Payment Plan"},
                        {id: 56, title: "25y Payment Plan"},
                        {id: 57, title: "10-90 Payment Plan"},
                        {id: 58, title: "20-80 Payment Plan"},
                        {id: 59, title: "30-70 Payment Plan"},
                        {id: 60, title: "40-60 Payment Plan"},
                        {id: 61, title: "50-50 Payment Plan"},
                        {id: 62, title: "60-40 Payment Plan"},
                        {id: 63, title: "70-30 Payment Plan"},
                        {id: 64, title: "25-75 Payment Plan"},
                    ],
                    title: "Payment Plan",
                    value: "-1"
                },
                "servicecharge": {
                    id: "servicecharge",
                    tab_value: "sell",
                    extra: true,
                    selections: [
                        {id: 0, title: "10y Free Service"},
                        {id: 1, title: "9y Free Service"},
                        {id: 2, title: "8y Free Service"},
                        {id: 3, title: "7y Free Service"},
                        {id: 4, title: "6y Free Service"},
                        {id: 5, title: "5y Free Service"},
                        {id: 6, title: "4y Free Service"},
                        {id: 7, title: "3y Free Service"},
                        {id: 8, title: "2y Free Service"},
                        {id: 9, title: "1y Free Service"},
                    ],
                    title: "Service Charge",
                    value: "-1"
                },
                "cheques": {
                    id: "cheques",
                    tab_value: "rent",
                    extra: true,
                    selections: [
                        {id: 0, title: "1 Cheque"},
                        {id: 1, title: "2 Cheques"},
                        {id: 2, title: "3 Cheques"},
                        {id: 3, title: "4 Cheques"},
                        {id: 4, title: "5 Cheques"},
                        {id: 5, title: "6 Cheques"},
                        {id: 6, title: "7 Cheques"},
                        {id: 7, title: "8 Cheques"},
                        {id: 8, title: "9 Cheques"},
                        {id: 9, title: "10 Cheques"},
                        {id: 10, title: "11 Cheques"},
                        {id: 11, title: "12 Cheques"},
                    ],
                    title: "Cheques",
                    value: "-1"
                },
                "freemonths": {
                    id: "freemonths",
                    tab_value: "rent",
                    extra: true,
                    selections: [
                        {id: 0, title: "1 Free Month"},
                        {id: 1, title: "2 Free Months"},
                        {id: 2, title: "3 Free Months"},
                        {id: 3, title: "4 Free Months"},
                    ],
                    title: "Free Months",
                    value: "-1"
                },
            };
            let sliders = {
                "size": {
                    id: "size",
                    tab_value: "sell",
                    min: 0,
                    max: 20000,
                    title: "Size",
                    rate: 1,
                    step: 1,
                    value: 0,
                    parameters: {
                        "sqft": {
                            rate: 1,
                            value: 0,
                            style_long: true,
                            title: "SQFT",
                            type: "input"
                        },
                        "sqm": {
                            rate: 0.093,
                            value: 0,
                            style_long: true,
                            title: "SQM",
                            type: "input"
                        },
                    },
                },
                "size_two": {
                    id: "size",
                    tab_value: "rent",
                    min: 0,
                    max: 20000,
                    title: "Size",
                    rate: 1,
                    step: 1,
                    value: 0,
                    parameters: {
                        "sqft": {
                            rate: 1,
                            value: 0,
                            style_long: true,
                            title: "SQFT",
                            type: "input"
                        },
                        "sqm": {
                            rate: 0.093,
                            value: 0,
                            style_long: true,
                            title: "SQM",
                            type: "input"
                        },
                    },
                },
                "price": {
                    id: "price",
                    tab_value: "sell",
                    min: 0,
                    max: 100000000,
                    title: "Price",
                    rate: 1,
                    step: 1,
                    value: 0,
                    parameters: {
                        "price": {
                            id: "price",
                            rate: 1,
                            value: 0,
                            style_long: true,
                            type: "input"
                        },
                        "currency": {
                            id: "currency",
                            value: "-1",
                            rate: 1,
                            style_long: true,
                            title: "Currency",
                            type: "input"
                        }
                    },
                },
                "price_two": {
                    id: "price",
                    tab_value: "rent",
                    min: 0,
                    max: 1000000,
                    title: "Price",
                    rate: 1,
                    step: 1,
                    value: 0,
                    parameters: {
                        "price": {
                            id: "price",
                            rate: 1,
                            value: 0,
                            style_long: true,
                            title: "AED",
                            type: "input"
                        },
                        "currency": {
                            id: "currency",
                            value: "-1",
                            rate: 1,
                            style_long: true,
                            title: "Currency",
                            type: "input"
                        },
                        "time": {
                            id: "time",
                            value: "-1",
                            style_long: true,
                            title: "Duration",
                            selections: [
                                {id: 0, title: "Yearly", step: 1, max: 2000000},
                                {id: 1, title: "Monthly", step: 1, max: 1000000},
                                {id: 2, title: "Weekly", step: 1, max: 200000},
                                {id: 3, title: "Daily", step: 1, max: 10000}
                            ],
                            type: "dropdown",
                            under: true,
                        }
                    },
                },
            };
            let amenities = {
                0: {
                    id: 0,
                    title: "Maids Room",
                    selected: false,
                },
                1: {
                    id: 1,
                    title: "Balcony",
                    selected: false,
                },
                2: {
                    id: 2,
                    title: "Study",
                    selected: false,
                },
                3: {
                    id: 3,
                    title: "Central AC",
                    selected: false,
                },
                4: {
                    id: 4,
                    title: "Private Garden",
                    selected: false,
                },
                5: {
                    id: 5,
                    title: "Private Pool",
                    selected: false,
                },
                6: {
                    id: 6,
                    title: "Private Gym",
                    selected: false
                },
                7: {
                    id: 7,
                    title: "Private Jacuzzi",
                    selected: false
                },
                8: {
                    id: 8,
                    title: "Built In Wardrobes",
                    selected: false
                },
                9: {
                    id: 9,
                    title: "Walk-in Closet",
                    selected: false
                },
                10: {
                    id: 10,
                    title: "Built In Kitchen Appliances",
                    selected: false
                },
                11: {
                    id: 11,
                    title: "View Of Water",
                    selected: false
                },
                12: {
                    id: 12,
                    title: "View Of Landmark",
                    selected: false
                },
                13: {
                    id: 13,
                    title: "Pets Allowed",
                    selected: false
                },
                14: {
                    id: 14,
                    title: "Central Heating",
                    selected: false
                },
                15: {
                    id: 15,
                    title: "Concierge Service",
                    selected: false
                },
                16: {
                    id: 16,
                    title: "Covered Parking",
                    selected: false
                },
                17: {
                    id: 17,
                    title: "Kitchen Appliances",
                    selected: false
                },
                18: {
                    id: 18,
                    title: "Shared Gym",
                    selected: false
                },
                19: {
                    id: 19,
                    title: "Shared Spa",
                    selected: false
                },
                20: {
                    id: 20,
                    title: "Shared Pool",
                    selected: false
                },
                21: {
                    id: 21,
                    title: "Kids Play Area",
                    selected: false
                },
                22: {
                    id: 22,
                    title: "Kids Pool",
                    selected: false
                },
                23: {
                    id: 23,
                    title: "Barbecue Area",
                    selected: false
                },
                24: {
                    id: 24,
                    title: "Maid Service",
                    selected: false
                },
                25: {
                    id: 25,
                    title: "Sea View",
                    selected: false
                },
                26: {
                    id: 26,
                    title: "Full Sea View",
                    selected: false
                },
                27: {
                    id: 27,
                    title: "Lake View",
                    selected: false
                },
                28: {
                    id: 28,
                    title: "Full Lake View",
                    selected: false
                },
                29: {
                    id: 29,
                    title: "Park View",
                    selected: false
                },
                30: {
                    id: 30,
                    title: "Full Park View",
                    selected: false
                },
                31: {
                    id: 31,
                    title: "High Floor",
                    selected: false
                },
                32: {
                    id: 32,
                    title: "Low Floor",
                    selected: false
                },
                33: {
                    id: 33,
                    title: "Mid Floor",
                    selected: false
                },
                34: {
                    id: 34,
                    title: "Skyline View",
                    selected: false
                },
                35: {
                    id: 35,
                    title: "Full Skyline View",
                    selected: false
                },
                36: {
                    id: 36,
                    title: "Beach Access",
                    selected: false
                },
                37: {
                    id: 37,
                    title: "Outdoor Terrace",
                    selected: false
                },
                38: {
                    id: 38,
                    title: "Double Balcony",
                    selected: false
                },
                39: {
                    id: 39,
                    title: "Golf Course View",
                    selected: false
                },
                40: {
                    id: 40,
                    title: "Golf Access",
                    selected: false
                },
                41: {
                    id: 41,
                    title: "Close To Nature",
                    selected: false
                },
                42: {
                    id: 42,
                    title: "Partial Sea View",
                    selected: false
                },
                43: {
                    id: 43,
                    title: "Partial Lake View",
                    selected: false
                },
                44: {
                    id: 44,
                    title: "Partial Park View",
                    selected: false
                },
                45: {
                    id: 45,
                    title: "Partial Skyline View",
                    selected: false
                },
                46: {
                    id: 46,
                    title: "Fountain View",
                    selected: false
                },
                47: {
                    id: 47,
                    title: "Gated Area",
                    selected: false
                },
                48: {
                    id: 48,
                    title: "Secured Parking",
                    selected: false
                },
                49: {
                    id: 49,
                    title: "Panoramic View",
                    selected: false
                },
                50: {
                    id: 50,
                    title: "Panoramic Sea View",
                    selected: false
                },
                51: {
                    id: 51,
                    title: "Panoramic Skyline View",
                    selected: false
                },
                52: {
                    id: 52,
                    title: "Car Park",
                    selected: false
                },
                53: {
                    id: 53,
                    title: "Canal View",
                    selected: false
                },
                54: {
                    id: 54,
                    title: "Full Canal View",
                    selected: false
                },
                55: {
                    id: 55,
                    title: "Partial Canal View",
                    selected: false
                },
                56: {
                    id: 56,
                    title: "Rooftop Garden",
                    selected: false
                },
                57: {
                    id: 57,
                    title: "Rooftop Pool",
                    selected: false
                },
                58: {
                    id: 58,
                    title: "Rooftop Gym",
                    selected: false
                },
                59: {
                    id: 59,
                    title: "Community View",
                    selected: false
                },
                60: {
                    id: 60,
                    title: "Marina View",
                    selected: false
                },
                61: {
                    id: 61,
                    title: "Yacht View",
                    selected: false
                },
                62: {
                    id: 62,
                    title: "Beachfront",
                    selected: false
                },
                63: {
                    id: 63,
                    title: "Private Elevator",
                    selected: false
                },
                64: {
                    id: 64,
                    title: "Private Spa",
                    selected: false
                },
                65: {
                    id: 65,
                    title: "Home Cinema",
                    selected: false
                },
                66: {
                    id: 66,
                    title: "Fireplace",
                    selected: false
                },
                67: {
                    id: 67,
                    title: "Home Office",
                    selected: false
                },
                68: {
                    id: 68,
                    title: "Boulevard View",
                    selected: false
                },
                69: {
                    id: 69,
                    title: "Burj View",
                    selected: false
                },
                70: {
                    id: 70,
                    title: "Mall Access",
                    selected: false
                },
                71: {
                    id: 71,
                    title: "Ain View",
                    selected: false
                },
                72: {
                    id: 72,
                    title: "Game Room",
                    selected: false
                }
            };
            this.setState({
                tabs: tabs,
                dropdowns: dropdowns,
                sliders: sliders,
                amenities: amenities
            }, () => {
                this.update.scraperData();
            });
        }
    };

    functions = {
        setTab: (key, value) => {
            if (this.state.tabs[key]) {
                for (let key_two in this.state.tabs) {
                    this.state.tabs[key_two].selected = false;
                }
                this.state.tabs[key].selected = value;
                this.setState({tabs: this.state.tabs}, () => {
                    quotesRegister.remove();
                    cartRegister.setQuotes(null);
                });
            }
        },
        setDropdown: (key, value) => {
            if (this.state.dropdowns[key]) {
                try {
                    this.state.dropdowns[key].error = false;
                    this.state.dropdowns[key].value = value;
                    this.setState({dropdowns: this.state.dropdowns, error: false}, () => {
                        try {
                            if (this.state.dropdowns[key].extra || this.state.dropdowns[key].extra_second) {
                                quotesRegister.remove();
                                cartRegister.setQuotes(null);
                            }
                            if (this.state.dropdowns[key].extra_second) {
                                cartRegister.setRelated(null)
                            }
                        } catch (e) {
                        }
                    });
                } catch (e) {
                }
            }
        },
        setSlider: (key, value) => {
            if (this.state.sliders[key]) {

                this.state.sliders[key].value = value;

                //SET PARAMETER VALUES
                for (let key_two in this.state.sliders[key].parameters) {
                    try {
                        if (key_two !== "currency" && key_two !== "time") {
                            this.state.sliders[key].parameters[key_two].value = Math.round(this.state.sliders[key].parameters[key_two].rate * value);
                        }
                    } catch (e) {}
                }

                this.setState({sliders: this.state.sliders});
            }
        },
        setSliderDropdown: (key, key_two, value) => {
            try {

                this.state.sliders[key].parameters[key_two].error = false;
                this.state.sliders[key].parameters[key_two].value = value;

                try {
                    if(key_two !== "currency"){
                        this.state.sliders[key].step = JSON.parse(value).step;
                        this.state.sliders[key].max = JSON.parse(value).max;
                        this.state.sliders[key].value = 0;

                        //SET PARAMETER INPUT TO ZERO
                        for (let key_two in this.state.sliders[key].parameters) {
                            try {
                                if (this.state.sliders[key].parameters[key_two].type === "input" && key_two !== "currency") {
                                    this.state.sliders[key].parameters[key_two].value = 0;
                                }
                            } catch (e) {}
                        }
                    }
                }catch (e) {}

                this.setState({sliders: this.state.sliders, error: false});
            } catch (e) {}
        },
        setAmenity: (key, value) => {
            if (this.state.amenities[key]) {
                quotesRegister.remove();
                cartRegister.setQuotes(null);
                this.state.amenities[key].selected = value;
                this.setState({amenities: this.state.amenities});
            }
        },
        setRegion: (target, level_key, init) => {

            console.log(target);

            if (target !== "-1") {

                this.state.region_grid[JSON.parse(target).level].error = false;
                this.state.region_grid[JSON.parse(target).level].value = target;
                target = JSON.parse(target);

                //RESET ALL LEVELS BELOW SELECTED TARGET
                for (let key in this.state.region_grid) {
                    if (+this.state.region_grid[key].level > +target.level) {
                        delete this.state.region_grid[key];
                    }
                }

                let level_cap = 5;
                let level_skip = 1;

                if (salesChannelRegister.get('name') === 'boostabostad') {
                    level_cap = 7;
                    level_skip = 1;
                }

                let level = +target.level + level_skip;

                if (level < level_cap) {
                    if(init){
                        try {
                            let scraper_data = JSON.parse(scraperRegister.get());
                            let search_query = scraper_data.additional_information.facts.places[1];
                            let match = false;
                            let current = false;
                            let parent = false;
                            if(search_query){
                                if (salesChannelRegister.get('name') === 'boostabostad') {
                                    //ON BOOSTA BOSTAD WE MATCH AGAINST TWO LEVELS (DEFAULT PLUS EXTRA LEVEL)
                                    //CHECK IF MATCH NEXT LOWEST LEVEL
                                    for (let i = 0; i < this.state.regions.length; i++) {
                                        if (this.state.regions[i].name.toLowerCase().indexOf(search_query.toLowerCase()) !== -1 && this.state.regions[i].level === level && this.state.regions[i].parent_id === target.id) {
                                            match = true;
                                            current = this.state.regions[i].id;
                                            this.state.region_grid[level] = {
                                                value: JSON.stringify(this.state.regions[i]),
                                                children: [],
                                                title: "Select",
                                                level: level
                                            };
                                        } else if (search_query.toLowerCase().indexOf(this.state.regions[i].name.toLowerCase()) !== -1 && this.state.regions[i].level === level && this.state.regions[i].parent_id === target.id) {
                                            match = true;
                                            current = this.state.regions[i].id;
                                            this.state.region_grid[level] = {
                                                value: JSON.stringify(this.state.regions[i]),
                                                children: [],
                                                title: "Select",
                                                level: level
                                            };
                                        }
                                    }
                                    if (!match) {
                                        //IF NO MATCH NEXT LOWEST LEVEL CHECK MATCH LOWEST LEVEL
                                        for (let i = 0; i < this.state.regions.length; i++) {
                                            if (this.state.regions[i].name.toLowerCase().indexOf(search_query.toLowerCase()) !== -1 && this.state.regions[i].level === level+1) {
                                                parent = this.state.regions[i].parent_id;
                                                console.log(this.state.regions[i].parent_id + " parent exit");
                                            } else if (search_query.toLowerCase().indexOf(this.state.regions[i].name.toLowerCase()) !== -1 && this.state.regions[i].level === level+1) {
                                                parent = this.state.regions[i].parent_id;
                                                console.log(this.state.regions[i].parent_id + " parent exit");
                                                console.log();
                                            }
                                        }
                                    }
                                    if (parent) {
                                        //IF MATCH LOWEST LEVEL SET NEXT LOWEST LEVEL
                                        for (let i = 0; i < this.state.regions.length; i++) {
                                            if (this.state.regions[i].level === level && this.state.regions[i].id === parent) {
                                                match = true;
                                                current = this.state.regions[i].id;
                                                console.log(this.state.regions[i].parent_id + " select parent");
                                                this.state.region_grid[level] = {
                                                    value: JSON.stringify(this.state.regions[i]),
                                                    children: [],
                                                    title: "Select",
                                                    level: level
                                                };
                                            } else if (this.state.regions[i].level === level && this.state.regions[i].id === parent) {
                                                match = true;
                                                current = this.state.regions[i].id;
                                                console.log(this.state.regions[i].parent_id + " select parent");
                                                this.state.region_grid[level] = {
                                                    value: JSON.stringify(this.state.regions[i]),
                                                    children: [],
                                                    title: "Select",
                                                    level: level
                                                };
                                            }
                                        }
                                    }
                                    if (current) {
                                        //IF MATCH NEXT LOWEST LEVEL SET LOWEST LEVEL
                                        for (let i = 0; i < this.state.regions.length; i++) {
                                            if (this.state.regions[i].name.toLowerCase().indexOf(search_query.toLowerCase()) !== -1 && this.state.regions[i].level === level+1 && this.state.regions[i].parent_id === current) {
                                                match = true;
                                                this.state.region_grid[level+1] = {
                                                    value: JSON.stringify(this.state.regions[i]),
                                                    children: [],
                                                    title: "Select",
                                                    level: level+1
                                                };
                                            } else if (search_query.toLowerCase().indexOf(this.state.regions[i].name.toLowerCase()) !== -1 && this.state.regions[i].level === level+1 && this.state.regions[i].parent_id === current) {
                                                match = true;
                                                this.state.region_grid[level+1] = {
                                                    value: JSON.stringify(this.state.regions[i]),
                                                    children: [],
                                                    title: "Select",
                                                    level: level+1
                                                };
                                            }
                                        }
                                    }
                                } else {
                                    //ON PROPERTY BOOSTER WE MATCH AGAINST ONE LEVEL (DEFAULT LEVEL)
                                    for (let i = 0; i < this.state.regions.length; i++) {
                                        if (this.state.regions[i].name.toLowerCase().indexOf(search_query.toLowerCase()) !== -1 && this.state.regions[i].level === level && this.state.regions[i].parent_id === target.id) {
                                            match = true;
                                            this.state.region_grid[level] = {
                                                value: JSON.stringify(this.state.regions[i]),
                                                children: [],
                                                title: "Select",
                                                level: level
                                            };
                                        } else if (search_query.toLowerCase().indexOf(this.state.regions[i].name.toLowerCase()) !== -1 && this.state.regions[i].level === level && this.state.regions[i].parent_id === target.id) {
                                            match = true;
                                            this.state.region_grid[level] = {
                                                value: JSON.stringify(this.state.regions[i]),
                                                children: [],
                                                title: "Select",
                                                level: level
                                            };
                                        }
                                    }
                                }
                                if(match){
                                    //SET DEFAULT LEVEL DATA
                                    for (let i = 0; i < this.state.regions.length; i++) {
                                        if (this.state.regions[i].country_code === target.country_code && this.state.regions[i].level === level && this.state.regions[i].parent_id === target.id) {
                                            this.state.region_grid[level].children.push(this.state.regions[i])
                                        }
                                    }
                                    //SET EXTRA LEVEL DATA
                                    if (salesChannelRegister.get('name') === 'boostabostad') {
                                        for (let i = 0; i < this.state.regions.length; i++) {
                                            if (this.state.regions[i].country_code === target.country_code && this.state.regions[i].level === level+1 && this.state.regions[i].parent_id === current) {
                                                this.state.region_grid[level+1].children.push(this.state.regions[i])
                                            }
                                        }
                                    }
                                } else {
                                    this.state.region_grid[level] = {
                                        value: "-1",
                                        children: [],
                                        title: "Select",
                                        level: level
                                    };
                                    for (let i = 0; i < this.state.regions.length; i++) {
                                        if (this.state.regions[i].parent_id === target.id && this.state.regions[i].level > target.level) {
                                            this.state.region_grid[level].children.push(this.state.regions[i])
                                        }
                                    }
                                    if (this.state.region_grid[level].children.length < 1) {
                                        delete this.state.region_grid[level];
                                    }
                                }
                            } else {
                                this.state.region_grid[level] = {
                                    value: "-1",
                                    children: [],
                                    title: "Select",
                                    level: level}
                                    ;
                                for (let i = 0; i < this.state.regions.length; i++) {
                                    if (this.state.regions[i].parent_id === target.id && this.state.regions[i].level > target.level) {
                                        this.state.region_grid[level].children.push(this.state.regions[i])
                                    }
                                }
                                if (this.state.region_grid[level].children.length < 1) {
                                    delete this.state.region_grid[level];
                                }
                            }
                        } catch (e) {
                            this.state.region_grid[level] = {
                                value: "-1",
                                children: [],
                                title: "Select",
                                level: level
                            };
                            for (let i = 0; i < this.state.regions.length; i++) {
                                if (this.state.regions[i].parent_id === target.id && this.state.regions[i].level > target.level) {
                                    this.state.region_grid[level].children.push(this.state.regions[i])
                                }
                            }
                            if (this.state.region_grid[level].children.length < 1) {
                                delete this.state.region_grid[level];
                            }
                        }
                    } else {
                        this.state.region_grid[level] = {value: "-1", children: [], title: "Select", level: level};
                        for (let i = 0; i < this.state.regions.length; i++) {
                            if (this.state.regions[i].parent_id === target.id && this.state.regions[i].level > target.level) {
                                this.state.region_grid[level].children.push(this.state.regions[i])
                            }
                        }
                        if (this.state.region_grid[level].children.length < 1) {
                            delete this.state.region_grid[level];
                        }
                    }
                }

            } else {

                this.state.region_grid[level_key].error = false;
                this.state.region_grid[level_key].value = target;

                //RESET ALL LEVELS BELOW SELECTED TARGET
                for (let key in this.state.region_grid) {
                    if (+this.state.region_grid[key].level > +level_key) {
                        delete this.state.region_grid[key];
                    }
                }

            }

            console.log(this.state.region_grid);

            try {
                if(+level_key === 1){
                    this.setState({
                        autocomplete_lat: null,
                        autocomplete_lng: null,
                        autocomplete_placeid: null,
                        autocomplete_full_address: null,
                        autocomplete_search: "",
                        autocomplete_address: null,
                        autocomplete_error: false,
                        autocomplete_predictions: []
                    });
                }
            } catch (e) {}

            let level_max = 4;
            if (salesChannelRegister.get('name') === 'boostabostad') {
                level_max = 5;
            }

            try {
                let cart = cartRegister.get();
                if (cart.display_region.level > level_key || +cart.display_region.level === +level_key){
                    this.state.display_region = null;
                    if (this.state.region_grid[level_key]){
                        this.state.display_region = JSON.parse(this.state.region_grid[level_key].value).id;
                        cartRegister.setDisplayRegion(JSON.parse(this.state.region_grid[level_key].value));
                    } else {
                        cartRegister.setDisplayRegion(null);
                    }
                } else if (cart.display_region.level < level_key && level_key < level_max){
                    this.state.display_region = null;
                    if(this.state.region_grid[level_key]){
                        this.state.display_region = JSON.parse(this.state.region_grid[level_key].value).id;
                        cartRegister.setDisplayRegion(JSON.parse(this.state.region_grid[level_key].value));
                    }else{
                        cartRegister.setDisplayRegion(null);
                    }
                }
            } catch (e) {}

            try {
                let scraper_data = JSON.parse(scraperRegister.get());
                if(scraper_data.additional_information.facts.places || this.state.scraper_data.additional_information.facts.places){
                    delete scraper_data.additional_information.facts.address_lat;
                    delete scraper_data.additional_information.facts.address_lng;
                    delete scraper_data.additional_information.facts.address_id;
                    delete scraper_data.additional_information.facts.address;
                    delete scraper_data.additional_information.facts.address_full;
                    delete scraper_data.additional_information.facts.places;

                    delete this.state.scraper_data.additional_information.facts.address_lat;
                    delete this.state.scraper_data.additional_information.facts.address_lng;
                    delete this.state.scraper_data.additional_information.facts.address_id;
                    delete this.state.scraper_data.additional_information.facts.address;
                    delete this.state.scraper_data.additional_information.facts.address_full;
                    delete this.state.scraper_data.additional_information.facts.places;
                }
                scraperRegister.set(scraper_data);
            }catch (e) {}

            this.setState({region_grid: this.state.region_grid, error: false, display_region: this.state.display_region}, () => {
                console.log(this.state.region_grid);
                if (!init) {
                    this.state.scraper_data.region_grid = this.state.region_grid;
                    scraperRegister.set(this.state.scraper_data);
                } else {
                    this.update.data();
                }
            });
        },
        setIndustry: (auto) => {
            try {

                cartRegister.setVideoAd(null);

                this.state.scraper_data.additional_information.slogans_exclude = [];

                //REMOVE SCRAPER REGIONS, SET REGION_GRID
                try {
                    this.state.scraper_data.region_grid = this.state.region_grid;
                }catch (e) {}
                try {
                    this.state.scraper_data.additional_information.facts.place = null;
                }catch (e) {}

                let error = false;
                let type = null;
                let type_error = false;
                for (let key in this.state.dropdowns) {
                    if (this.state.dropdowns[key].id === "type" && this.state.tabs[this.state.dropdowns[key].tab_value].selected) {
                        if (this.state.dropdowns[key].value !== "-1") {
                            this.state.dropdowns[key].error = false;
                            type = JSON.parse(this.state.dropdowns[key].value).title.toLowerCase();
                        } else {
                            //SET ERROR FOR USER TO SELECT
                            this.state.dropdowns[key].error = true;
                            //type_error = true;
                            error = true;
                        }
                    }
                }
                if (!type_error) {
                    let string = "";
                    let beds_error = false;
                    let beds = null;
                    for (let key in this.state.dropdowns) {
                        if (this.state.dropdowns[key].id === "beds" && this.state.tabs[this.state.dropdowns[key].tab_value].selected) {
                            if (this.state.dropdowns[key].value !== "-1") {
                                this.state.dropdowns[key].error = false;
                                beds = JSON.parse(this.state.dropdowns[key].value).title.toLowerCase();
                            } else {
                                //SET ERROR FOR USER TO SELECT
                                this.state.dropdowns[key].error = true;
                                //beds_error = true;
                                error = true;
                            }
                        }
                    }

                    if (!beds_error) {
                        try {
                            beds = beds.toLowerCase();
                            type = type.toLowerCase();
                        } catch (e) {}
                        try {
                            beds = beds.trim();
                            type = type.trim();
                        } catch (e) {}
                        try {
                            beds = beds.replace(/\s/g, '');
                            type = type.replace(/\s/g, '');
                        } catch (e) {}
                        try {
                            if(type === 'apartment'){
                                string = beds + "for";
                            }else{
                                string = type + "for";
                            }
                        }catch (e) {}
                        for (let key in this.state.tabs) {
                            if (this.state.tabs[key].selected) {
                                string = string + this.state.tabs[key].indentifier.toLowerCase();
                            }
                        }
                    }

                    //BATHS
                    try {
                        let baths = null;
                        for (let key in this.state.dropdowns) {
                            if (this.state.dropdowns[key].id === "baths" && this.state.tabs[this.state.dropdowns[key].tab_value].selected) {
                                if (this.state.dropdowns[key].value !== "-1") {
                                    baths = JSON.parse(this.state.dropdowns[key].value).amount;
                                    break;
                                } else {
                                    this.state.dropdowns[key].error = true;
                                    error = true;
                                    break;
                                }
                            }
                        }
                        this.state.scraper_data.additional_information.facts.bathrooms = baths;
                    } catch (e) {
                        console.log(e);
                    }

                    //PRICE DURATION (RENTAL)
                    try {
                        let duration = null;
                        for (let key in this.state.sliders) {
                            if (this.state.sliders[key].id === "price" && this.state.tabs[this.state.sliders[key].tab_value].selected) {
                                for (let key_two in this.state.sliders[key].parameters) {
                                    if (this.state.sliders[key].parameters[key_two].id === "time") {
                                        if (this.state.sliders[key].parameters[key_two].value !== "-1") {
                                            duration = JSON.parse(this.state.sliders[key].parameters[key_two].value);
                                            break;
                                        } else {
                                            this.state.sliders[key].parameters[key_two].error = true;
                                            error = true;
                                            break;
                                        }
                                    }
                                }
                            }
                        }
                        this.state.scraper_data.additional_information.facts.duration = duration;
                    } catch (e) {
                        console.log(e);
                    }

                    //FURNISHING (RENTAL)
                    try {
                        let furniture = null;
                        for (let key in this.state.dropdowns) {
                            if (this.state.dropdowns[key].id === "furniture" && this.state.tabs[this.state.dropdowns[key].tab_value].selected) {

                                if (this.state.dropdowns[key].value !== "-1") {
                                    furniture = JSON.parse(this.state.dropdowns[key].value);
                                } else {
                                    this.state.dropdowns[key].error = true;
                                    error = true;
                                }

                                //EXCLUDE OTHERS IN SLOGANS
                                if (furniture !== "-1" && furniture !== -1) {
                                    for (let i = 0; i < this.state.dropdowns[key].selections.length; i++) {
                                        if (furniture.id !== this.state.dropdowns[key].selections[i].id) {
                                            this.state.scraper_data.additional_information.slogans_exclude.push(this.state.dropdowns[key].selections[i].title);
                                        }
                                    }
                                }

                                break;
                            }
                        }
                        this.state.scraper_data.additional_information.facts.furnishings = furniture;

                    } catch (e) {
                        console.log(e);
                    }

                    //COMPLETION STATUS
                    try {
                        let status = null;
                        for (let key in this.state.dropdowns) {
                            if (this.state.dropdowns[key].id === "status" && this.state.tabs[this.state.dropdowns[key].tab_value].selected) {

                                if (this.state.dropdowns[key].value !== "-1") {
                                    status = JSON.parse(this.state.dropdowns[key].value);
                                } else {
                                    this.state.dropdowns[key].error = true;
                                    error = true;
                                }

                                //EXCLUDE OTHERS IN SLOGANS
                                if (status !== -1 && status !== "-1") {
                                    for (let i = 0; i < this.state.dropdowns[key].selections.length; i++) {
                                        if (status.id !== this.state.dropdowns[key].selections[i].id) {
                                            this.state.scraper_data.additional_information.slogans_exclude.push(this.state.dropdowns[key].selections[i].title);
                                        }
                                    }
                                }

                                break;
                            }
                        }
                        this.state.scraper_data.additional_information.facts.completion_status = status;
                    } catch (e) {
                        console.log(e);
                    }

                    //MATCH AGAINST INDUSTRY
                    for (let i = 0; i < this.state.industries.length; i++) {
                        let title = this.state.industries[i].name;
                        try {
                            title = title.toLowerCase();
                        } catch (e) {}
                        try {
                            title = title.trim();
                        } catch (e) {}
                        try {
                            title = title.replace(/\s/g, '');
                        } catch (e) {}
                        if (string === title) {

                            let cart = cartRegister.get();
                            try {
                                if(cart.industry.id !== this.state.industries[i].id){
                                    cartRegister.removeBudget();
                                    cartRegister.setRelated(null);
                                }
                            }catch (e) {
                                cartRegister.removeBudget();
                                cartRegister.setRelated(null);
                            }

                            //SET INDUSTRY
                            cartRegister.setIndustry(this.state.industries[i]);


                            //SET LISTING-DATA
                            let scraper_data = JSON.parse(scraperRegister.get());

                            //LISTING TYPE
                            try {
                                let listing_type = null;
                                for (let key in this.state.tabs) {
                                    if (this.state.tabs[key].selected) {
                                        listing_type = this.state.tabs[key];
                                        break;
                                    }
                                }
                                this.state.scraper_data.additional_information.facts.listing_type = listing_type;
                            } catch (e) {
                                console.log(e);
                            }

                            //IDENTIFIER
                            try {
                                let identifier = null;
                                for (let key in this.state.dropdowns) {
                                    if (this.state.dropdowns[key].id === "identifier" && this.state.tabs[this.state.dropdowns[key].tab_value].selected) {
                                        identifier = JSON.parse(this.state.dropdowns[key].value);
                                        break;
                                    }
                                }
                                this.state.scraper_data.additional_information.facts.identifier = identifier;
                            } catch (e) {
                                console.log(e);
                            }

                            //TYPE
                            try {
                                let type = null;
                                for (let key in this.state.dropdowns) {
                                    if (this.state.dropdowns[key].id === "type" && this.state.tabs[this.state.dropdowns[key].tab_value].selected) {
                                        type = JSON.parse(this.state.dropdowns[key].value);
                                        break;
                                    }
                                }
                                this.state.scraper_data.additional_information.facts.type = type;
                            } catch (e) {
                                console.log(e);
                            }

                            //BEDS
                            try {
                                let beds = null;
                                for (let key in this.state.dropdowns) {
                                    if (this.state.dropdowns[key].id === "beds" && this.state.tabs[this.state.dropdowns[key].tab_value].selected) {
                                        beds = JSON.parse(this.state.dropdowns[key].value).amount;
                                        break;
                                    }
                                }
                                this.state.scraper_data.additional_information.facts.bedrooms = beds;
                            } catch (e) {
                                console.log(e);
                            }

                            //SIZE
                            try {
                                let area_sqft = null;
                                for (let key in this.state.sliders) {
                                    if (this.state.sliders[key].id === "size" && this.state.tabs[this.state.sliders[key].tab_value].selected) {
                                        area_sqft = JSON.parse(this.state.sliders[key].value);
                                        break;
                                    }
                                }
                                this.state.scraper_data.additional_information.facts.area_sqft = area_sqft;
                            } catch (e) {
                                console.log(e);
                            }

                            //REGIONS
                            try {
                                this.state.scraper_data.region_grid = this.state.region_grid;
                            } catch (e) {
                                console.log(e);
                            }

                            //ADDRESS
                            if(!auto){
                                try {
                                    if(this.state.autocomplete_placeid){
                                        this.state.scraper_data.additional_information.facts.address_lat = this.state.autocomplete_lat;
                                        this.state.scraper_data.additional_information.facts.address_lng = this.state.autocomplete_lng;
                                        this.state.scraper_data.additional_information.facts.address_id = this.state.autocomplete_placeid;
                                        this.state.scraper_data.additional_information.facts.address = this.state.autocomplete_address;
                                        this.state.scraper_data.additional_information.facts.address_full = this.state.autocomplete_full_address;
                                    }else{
                                        this.setState({autocomplete_error: true});
                                        error = true;
                                    }
                                } catch (e) {
                                    console.log(e);
                                }
                            }

                            //CURRENCY
                            try {
                                let currency = null;
                                for (let key in this.state.dropdowns) {
                                    if (this.state.dropdowns[key].id === "currency" && this.state.tabs[this.state.dropdowns[key].tab_value].selected) {
                                        currency = JSON.parse(this.state.dropdowns[key].value).title;
                                    }
                                }
                                this.state.scraper_data.additional_information.facts.currency = currency;
                            } catch (e) {
                                console.log(e);
                            }

                            //SET BASE CURRENCY
                            try {
                                this.state.scraper_data.additional_information.facts.base_currency = salesChannelRegister.get('currency').toUpperCase();
                            }catch (e) {
                                console.log(e);
                            }

                            //SET PRICE
                            try {
                                let price = null;
                                for (let key in this.state.sliders) {
                                    if (this.state.sliders[key].id === "price" && this.state.tabs[this.state.sliders[key].tab_value].selected) {
                                        price = JSON.parse(this.state.sliders[key].value);
                                        break;
                                    }
                                }
                                this.state.scraper_data.additional_information.facts.price = Math.round(price * this.state.currencies_data[this.state.scraper_data.additional_information.facts.currency]);
                            }catch (e) {
                                console.log(e);
                            }

                            //SET BASE PRICE
                            try {
                                let price = null;
                                for (let key in this.state.sliders) {
                                    if (this.state.sliders[key].id === "price" && this.state.tabs[this.state.sliders[key].tab_value].selected) {
                                        price = JSON.parse(this.state.sliders[key].value);
                                        break;
                                    }
                                }
                                this.state.scraper_data.additional_information.facts.base_price = price;
                            } catch (e) {
                                console.log(e);
                            }

                            //AMENITIES
                            try {
                                let ameninities = [];
                                for (let key in this.state.amenities) {
                                    ameninities.push(this.state.amenities[key]);
                                }
                                this.state.scraper_data.slogans = ameninities;
                            } catch (e) {
                                console.log(e);
                            }

                            //EXTRA -> DISCOUNT
                            try {
                                let discount = null;
                                for (let key in this.state.dropdowns) {
                                    if (this.state.dropdowns[key].id === "discount" && this.state.tabs[this.state.dropdowns[key].tab_value].selected) {
                                        if (this.state.dropdowns[key].value !== '-1') {
                                            discount = JSON.parse(this.state.dropdowns[key].value);
                                            break;
                                        } else {
                                            break;
                                        }
                                    }
                                }
                                this.state.scraper_data.additional_information.facts.discount = discount;
                            } catch (e) {
                                console.log(e);
                            }

                            //EXTRA -> DLD WAIVER
                            try {
                                let dldwaiver = null;
                                for (let key in this.state.dropdowns) {
                                    if (this.state.dropdowns[key].id === "dldwaiver" && this.state.tabs[this.state.dropdowns[key].tab_value].selected) {
                                        if (this.state.dropdowns[key].value !== '-1') {
                                            dldwaiver = JSON.parse(this.state.dropdowns[key].value);
                                            break;
                                        } else {
                                            break;
                                        }
                                    }
                                }
                                this.state.scraper_data.additional_information.facts.dldwaiver = dldwaiver;
                            } catch (e) {
                                console.log(e);
                            }

                            //EXTRA -> DOWN PAYMENT
                            try {
                                let downpayment = null;
                                for (let key in this.state.dropdowns) {
                                    if (this.state.dropdowns[key].id === "downpayment" && this.state.tabs[this.state.dropdowns[key].tab_value].selected) {
                                        if (this.state.dropdowns[key].value !== '-1') {
                                            downpayment = JSON.parse(this.state.dropdowns[key].value);
                                            break;
                                        } else {
                                            break;
                                        }
                                    }
                                }
                                this.state.scraper_data.additional_information.facts.downpayment = downpayment;
                            } catch (e) {
                                console.log(e);
                            }

                            //EXTRA -> FINANCE
                            try {
                                let finance = null;
                                for (let key in this.state.dropdowns) {
                                    if (this.state.dropdowns[key].id === "finance" && this.state.tabs[this.state.dropdowns[key].tab_value].selected) {
                                        if (this.state.dropdowns[key].value !== '-1') {
                                            finance = JSON.parse(this.state.dropdowns[key].value);
                                            break;
                                        } else {
                                            break;
                                        }
                                    }
                                }
                                this.state.scraper_data.additional_information.facts.finance = finance;
                            } catch (e) {
                                console.log(e);
                            }

                            //EXTRA -> PAYMENT PLAN
                            try {
                                let paymentplan = null;
                                for (let key in this.state.dropdowns) {
                                    if (this.state.dropdowns[key].id === "paymentplan" && this.state.tabs[this.state.dropdowns[key].tab_value].selected) {
                                        if (this.state.dropdowns[key].value !== '-1') {
                                            paymentplan = JSON.parse(this.state.dropdowns[key].value);
                                            break;
                                        } else {
                                            break;
                                        }
                                    }
                                }
                                this.state.scraper_data.additional_information.facts.paymentplan = paymentplan;
                            } catch (e) {
                                console.log(e);
                            }

                            //EXTRA -> SERVICE CHARGE
                            try {
                                let servicecharge = null;
                                for (let key in this.state.dropdowns) {
                                    if (this.state.dropdowns[key].id === "servicecharge" && this.state.tabs[this.state.dropdowns[key].tab_value].selected) {
                                        if (this.state.dropdowns[key].value !== '-1') {
                                            servicecharge = JSON.parse(this.state.dropdowns[key].value);
                                            break;
                                        } else {
                                            break;
                                        }
                                    }
                                }
                                this.state.scraper_data.additional_information.facts.servicecharge = servicecharge;
                            } catch (e) {
                                console.log(e);
                            }

                            //EXTRA -> CHEQUES
                            try {
                                let cheques = null;
                                for (let key in this.state.dropdowns) {
                                    if (this.state.dropdowns[key].id === "cheques" && this.state.tabs[this.state.dropdowns[key].tab_value].selected) {
                                        if (this.state.dropdowns[key].value !== '-1') {
                                            cheques = JSON.parse(this.state.dropdowns[key].value);
                                            break;
                                        } else {
                                            break;
                                        }
                                    }
                                }
                                this.state.scraper_data.additional_information.facts.cheques = cheques;
                            } catch (e) {
                                console.log(e);
                            }

                            //EXTRA -> FREE MONTHS
                            try {
                                let freemonths = null;
                                for (let key in this.state.dropdowns) {
                                    if (this.state.dropdowns[key].id === "freemonths" && this.state.tabs[this.state.dropdowns[key].tab_value].selected) {
                                        if (this.state.dropdowns[key].value !== '-1') {
                                            freemonths = JSON.parse(this.state.dropdowns[key].value);
                                            break;
                                        } else {
                                            break;
                                        }
                                    }
                                }
                                this.state.scraper_data.additional_information.facts.freemonths = freemonths;
                            } catch (e) {
                                console.log(e);
                            }

                            //EXTRA -> ROI
                            try {
                                let roi = null;
                                for (let key in this.state.dropdowns) {
                                    if (this.state.dropdowns[key].id === "roi" && this.state.tabs[this.state.dropdowns[key].tab_value].selected) {
                                        if (this.state.dropdowns[key].value !== '-1') {
                                            roi = JSON.parse(this.state.dropdowns[key].value);
                                            break;
                                        } else {
                                            break;
                                        }
                                    }
                                }
                                this.state.scraper_data.additional_information.facts.roi = roi;
                            } catch (e) {
                                console.log(e);
                            }

                            //CHECK REGIONS
                            try {
                                let exist = false;
                                if (this.state.region_grid) {
                                    for (let key in this.state.region_grid) {
                                        if (+this.state.region_grid[key].level === 1) {
                                            if (this.state.region_grid[key].value !== "-1" && this.state.region_grid[key].value !== "-1") {
                                                exist = true;
                                                break;
                                            } else {
                                                this.state.region_grid[key].error = true;
                                                error = true;
                                                break;
                                            }
                                        }
                                    }
                                    if (exist && !error) {
                                        scraperRegister.set(this.state.scraper_data);
                                        if (auto) {
                                            try {
                                                let cart = cartRegister.get();
                                                dataRegister.quotes(cart.industry.id, salesChannelRegister.get('market'), langRegister.lang()).then((response_one) => {
                                                    let scraper_data = JSON.parse(scraperRegister.get());
                                                    if (scraper_data.images.length > 0) {

                                                        let images = [];
                                                        let checked = false;
                                                        for (let i = 0; i < scraper_data.images.length; i++) {
                                                            if(scraper_data.images[i].id) {
                                                                checked = true;
                                                            }else{
                                                                checked = false;
                                                                break;
                                                            }
                                                        }

                                                        if(!checked){
                                                            for (i = 0; i < scraper_data.images.length; i++) {
                                                                //LIMIT IMAGES (REMOVE ALL ABOVE 25)
                                                                if (i < 25) {
                                                                    let image_object = {
                                                                        url: scraper_data.images[i],
                                                                        web_url: scraper_data.images[i],
                                                                        id: "uploaded_image",
                                                                        date: Math.floor(Math.random() * 999999999999999999999),
                                                                        description: "scraped",
                                                                        isAnalyzing: false,
                                                                        isValid: false,
                                                                        isAnalyzed: false
                                                                    };
                                                                    images.push(this.functions.analyzeScrapedImage(image_object));
                                                                }
                                                            }
                                                        }else{
                                                            for (i = 0; i < scraper_data.images.length; i++) {
                                                                //LIMIT IMAGES (REMOVE ALL ABOVE 25)
                                                                if (i < 25) {
                                                                    images.push(this.functions.setAnalyzedImage(scraper_data.images[i]));
                                                                }
                                                            }
                                                        }

                                                        //ANALYZE EACH IMAGE, REMOVE THOSE NOT ACCEPTED
                                                        Promise.all(images).then((results) => {

                                                            //SET LABELS BY SCORE
                                                            try {
                                                                let scores = {};
                                                                for (let i = 0; i < results.length; i++) {
                                                                    if(i !== 0){
                                                                        try {
                                                                            if(results[i].temp_label){
                                                                                if(scores[results[i].temp_label.id]){
                                                                                    if(scores[results[i].temp_label.id].score < results[i].temp_label.score){
                                                                                        scores[results[i].temp_label.id] = {
                                                                                            score: results[i].temp_label.score,
                                                                                            image_id: results[i].date
                                                                                        };
                                                                                    }
                                                                                }else{
                                                                                    scores[results[i].temp_label.id] = {
                                                                                        score: results[i].temp_label.score,
                                                                                        image_id: results[i].date
                                                                                    };
                                                                                }
                                                                            }
                                                                        }catch (e) {}
                                                                    }else{
                                                                        results[i].temp_label = null;
                                                                        results[i].tag = "-1";
                                                                        results[i].label = null;
                                                                    }
                                                                }
                                                                for (let i = 0; i < results.length; i++) {
                                                                    try {
                                                                        if(results[i].temp_label){

                                                                            if(scores[results[i].temp_label.id].image_id === results[i].date){
                                                                                results[i].label = results[i].temp_label;
                                                                                results[i].temp_label = null;
                                                                            }else{
                                                                                results[i].label = null;
                                                                                results[i].temp_label = null;
                                                                                results[i].tag = "-1"
                                                                            }

                                                                        }
                                                                    }catch (e) {
                                                                        console.log(e);
                                                                    }
                                                                    try {
                                                                        if(results[i].label){

                                                                            let tags = [
                                                                                {id: 0, title: "Bedroom"},
                                                                                {id: 1, title: "Kitchen"},
                                                                                {id: 2, title: "Balcony"},
                                                                                {id: 3, title: "Bathroom"},
                                                                                {id: 4, title: "Pool"},
                                                                                {id: 5, title: "Gym"},
                                                                                {id: 6, title: "Living Room"},
                                                                                {id: 7, title: "Garden"},
                                                                                // NEW ONES START HERE
                                                                                {id: 8, title: "Terrace"},
                                                                                {id: 9, title: "Hallway"},
                                                                                {id: 10, title: "Home Cinema"},
                                                                                {id: 11, title: "Walk-in Closet"},
                                                                                {id: 12, title: "Hot Tub"},
                                                                                {id: 13, title: "Fireplace"},
                                                                                {id: 14, title: "Home Office"},
                                                                                {id: 15, title: "Beach Access"},
                                                                                {id: 16, title: "Dining Area"},
                                                                                {id: 17, title: "Golf Access"},
                                                                                {id: 18, title: "Game Room"},
                                                                                {id: 19, title: "Spa"},
                                                                                {id: 20, title: "Floor Plan"},
                                                                            ];

                                                                            //SET TAG SELECTED
                                                                            for (let m = 0; m < tags.length; m++) {
                                                                                if(results[i].label.id === tags[m].id){
                                                                                    results[i].tag = JSON.stringify(tags[m]);
                                                                                }
                                                                            }

                                                                        }
                                                                    }catch (e) {
                                                                        console.log(e);
                                                                    }
                                                                }
                                                            }catch (e) {
                                                                console.log(e);
                                                            }

                                                            let first_image = null;
                                                            for(let i = 0; i < results.length; i++){
                                                                if(results[i].isValid){
                                                                    results[i].selected = true;
                                                                    first_image = results[i];
                                                                    break;
                                                                }
                                                            }

                                                            let valid_images = [];
                                                            for(let i = 0; i < results.length; i++){
                                                                if(results[i].isValid){
                                                                    valid_images.push(results[i]);
                                                                }
                                                            }

                                                            scraper_data.images = valid_images;
                                                            scraperRegister.set(scraper_data);

                                                            if(first_image){
                                                                this.functions.dataUrl(first_image.web_url).then((response_two) => {
                                                                    try {
                                                                        let image_object = {
                                                                            url: response_two.data_url,
                                                                            web_url: response_two.web_url,
                                                                            id: "uploaded_image",
                                                                            description: "scraped"
                                                                        };
                                                                        let slogans = {};

                                                                        // ** BELOW NOT IN USE ** THIS SECTION WAS USED TO AUTO POPULATE SLOGANS FOR AUTO CROSSROAD
                                                                        let amenities_slogans = [];
                                                                        let extra_slogans = {
                                                                            a: [],
                                                                            b: [],
                                                                            c: [],
                                                                            d: []
                                                                        };
                                                                        let index = 0;
                                                                        for (let i = 0; i < response_one.length; i++) {
                                                                            for (let key in this.state.amenities) {
                                                                                if ((this.state.amenities[key].title.toLowerCase() === response_one[i].slogan.toLowerCase()) && response_one[i].type === 'property' && this.state.amenities[key].selected) {
                                                                                    if (amenities_slogans.length < 4) {
                                                                                        amenities_slogans.push(response_one[i]);
                                                                                        break;
                                                                                    } else {
                                                                                        break;
                                                                                    }
                                                                                }
                                                                            }

                                                                            //FIND EXTRA SLOGANS
                                                                            if (
                                                                                (
                                                                                    response_one[i].slogan.toLowerCase() === 'live the dream' ||
                                                                                    response_one[i].slogan.toLowerCase() === 'signature living'
                                                                                ) && response_one[i].type === 'property') {
                                                                                extra_slogans['a'].push(response_one[i]);
                                                                            } else if (
                                                                                (
                                                                                    response_one[i].slogan.toLowerCase() === 'newly listed' ||
                                                                                    response_one[i].slogan.toLowerCase() === 'value for money' ||
                                                                                    response_one[i].slogan.toLowerCase() === 'well planned'
                                                                                ) && response_one[i].type === 'property') {
                                                                                extra_slogans['b'].push(response_one[i]);
                                                                            } else if (
                                                                                (
                                                                                    response_one[i].slogan.toLowerCase() === 'amazing deal' ||
                                                                                    response_one[i].slogan.toLowerCase() === 'best deal' ||
                                                                                    response_one[i].slogan.toLowerCase() === 'last chance'
                                                                                ) && response_one[i].type === 'property') {
                                                                                extra_slogans['c'].push(response_one[i]);
                                                                            } else if (
                                                                                (
                                                                                    response_one[i].slogan.toLowerCase() === 'get in touch' ||
                                                                                    response_one[i].slogan.toLowerCase() === 'view today' ||
                                                                                    response_one[i].slogan.toLowerCase() === 'call now!' ||
                                                                                    response_one[i].slogan.toLowerCase() === 'instant call back'
                                                                                ) && response_one[i].type === 'property') {
                                                                                extra_slogans['d'].push(response_one[i]);
                                                                            }
                                                                        }

                                                                        // CHECK IF 4 SLOGANS SELECTED
                                                                        // A
                                                                        let random = Math.floor(Math.random() * extra_slogans['a'].length);
                                                                        slogans[extra_slogans['a'][random].id] = extra_slogans['a'][random];
                                                                        slogans[extra_slogans['a'][random].id].selected = true;
                                                                        slogans[extra_slogans['a'][random].id].index = index;
                                                                        index++;

                                                                        // B
                                                                        if (amenities_slogans.length > 0) {
                                                                            slogans[amenities_slogans[0].id] = amenities_slogans[0];
                                                                            slogans[amenities_slogans[0].id].index = index;
                                                                            index++;
                                                                        }else{
                                                                            let random = Math.floor(Math.random() * extra_slogans['b'].length);
                                                                            slogans[extra_slogans['b'][random].id] = extra_slogans['b'][random];
                                                                            slogans[extra_slogans['b'][random].id].selected = true;
                                                                            slogans[extra_slogans['b'][random].id].index = index;
                                                                            index++;
                                                                        }

                                                                        // C
                                                                        if (amenities_slogans.length > 1) {
                                                                            slogans[amenities_slogans[1].id] = amenities_slogans[1];
                                                                            slogans[amenities_slogans[1].id].index = index;
                                                                            index++;
                                                                        }else{
                                                                            let random = Math.floor(Math.random() * extra_slogans['c'].length);
                                                                            slogans[extra_slogans['c'][random].id] = extra_slogans['c'][random];
                                                                            slogans[extra_slogans['c'][random].id].selected = true;
                                                                            slogans[extra_slogans['c'][random].id].index = index;
                                                                            index++;
                                                                        }

                                                                        // D
                                                                        random = Math.floor(Math.random() * extra_slogans['d'].length);
                                                                        slogans[extra_slogans['d'][random].id] = extra_slogans['d'][random];
                                                                        slogans[extra_slogans['d'][random].id].selected = true;
                                                                        slogans[extra_slogans['d'][random].id].index = index;

                                                                        // ** ABOVE NOT IN USE **

                                                                        console.log(this.state.region_grid);

                                                                        //SET GOOGLE LOOKUP
                                                                        try {
                                                                            let self = this;
                                                                            let search_query = "";
                                                                            try {
                                                                                if(scraper_data.additional_information.facts.places.length > 1){
                                                                                    search_query = scraper_data.additional_information.facts.places[0] + " " + scraper_data.additional_information.facts.places[1]
                                                                                }else{
                                                                                    self.setState({
                                                                                        autocomplete_error: true,
                                                                                        region_grid: self.state.region_grid,
                                                                                        sliders: self.state.sliders,
                                                                                        dropdowns: self.state.dropdowns,
                                                                                        isLoading: false
                                                                                    });
                                                                                }
                                                                            }catch (e) {
                                                                                self.setState({
                                                                                    autocomplete_error: true,
                                                                                    region_grid: self.state.region_grid,
                                                                                    sliders: self.state.sliders,
                                                                                    dropdowns: self.state.dropdowns,
                                                                                    isLoading: false
                                                                                });
                                                                            }

                                                                            this.autocomplete.getPlacePredictions({
                                                                                input: search_query,
                                                                                componentRestrictions: {country: JSON.parse(this.state.region_grid[1].value).country_code}
                                                                            }, function (predictions, status) {
                                                                                console.log(predictions);
                                                                                if (status === 'OK' && predictions && predictions.length > 0) {
                                                                                    self.geocoder.geocode({'placeId': predictions[0].place_id}, function (results, status) {
                                                                                        console.log(results);
                                                                                        if (status === 'OK' && results && results.length > 0) {

                                                                                            scraper_data.additional_information.facts.address_lat = results[0].geometry.location.lat();
                                                                                            scraper_data.additional_information.facts.address_lng = results[0].geometry.location.lng();
                                                                                            scraper_data.additional_information.facts.address_id = predictions[0].place_id;
                                                                                            scraper_data.additional_information.facts.address_full = predictions[0].description;
                                                                                            scraper_data.additional_information.facts.address = predictions[0].structured_formatting.main_text;

                                                                                            scraperRegister.set(scraper_data);
                                                                                            cartRegister.setQuotes(slogans);
                                                                                            cartRegister.setAdminImage(image_object);

                                                                                            self.props.history.push("/" + salesChannelRegister.get('market') + "/" + langRegister.lang() + "/booster/ads");

                                                                                        } else {
                                                                                            self.setState({
                                                                                                autocomplete_error: true,
                                                                                                region_grid: self.state.region_grid,
                                                                                                sliders: self.state.sliders,
                                                                                                dropdowns: self.state.dropdowns,
                                                                                                isLoading: false
                                                                                            });
                                                                                        }
                                                                                    });
                                                                                } else {
                                                                                    self.setState({
                                                                                        autocomplete_error: true,
                                                                                        region_grid: self.state.region_grid,
                                                                                        sliders: self.state.sliders,
                                                                                        dropdowns: self.state.dropdowns,
                                                                                        isLoading: false
                                                                                    });
                                                                                }
                                                                            });

                                                                        }catch (e) {
                                                                            this.setState({
                                                                                autocomplete_error: true,
                                                                                region_grid: this.state.region_grid,
                                                                                sliders: this.state.sliders,
                                                                                dropdowns: this.state.dropdowns,
                                                                                isLoading: false
                                                                            });
                                                                        }
                                                                    } catch (e) {
                                                                        console.log(e);
                                                                        this.props.history.push("/" + salesChannelRegister.get('market') + "/" + langRegister.lang() + "/booster/images");
                                                                    }
                                                                });
                                                            }else{
                                                                //NO VALID IMAGE EXISTED
                                                                this.props.history.push("/" + salesChannelRegister.get('market') + "/" + langRegister.lang() + "/booster/images");
                                                            }
                                                        });
                                                    } else {
                                                        this.props.history.push("/" + salesChannelRegister.get('market') + "/" + langRegister.lang() + "/booster/images");
                                                    }
                                                }, (e) => {
                                                    console.log(e);
                                                    this.props.history.push("/" + salesChannelRegister.get('market') + "/" + langRegister.lang() + "/booster/images");
                                                });
                                            } catch (e) {
                                                console.log(e);
                                                this.props.history.push("/" + salesChannelRegister.get('market') + "/" + langRegister.lang() + "/booster/images");
                                            }
                                        } else {
                                            this.props.history.push("/" + salesChannelRegister.get('market') + "/" + langRegister.lang() + "/booster/images");
                                        }
                                    } else {
                                        this.setState({
                                            region_grid: this.state.region_grid,
                                            sliders: this.state.sliders,
                                            dropdowns: this.state.dropdowns,
                                            isLoading: false
                                        });
                                        break;
                                    }
                                }
                            } catch (e) {
                                console.log(e);
                                break;
                            }

                        }
                    }

                }

                //SAVE ERRORS
                this.setState({sliders: this.state.sliders, dropdowns: this.state.dropdowns, error: error}, () => {
                });

            } catch (e) {
                console.log(e);
            }

        },
        increaseSlider: (key) => {
            let value = +this.state.sliders[key].value + +this.state.sliders[key].step;
            if (value >= this.state.sliders[key].max) {
                value = this.state.sliders[key].max;
            }
            this.functions.setSlider(key, value);
        },
        decreaseSlider: (key) => {
            let value = +this.state.sliders[key].value - +this.state.sliders[key].step;
            if (value <= 0) {
                value = 0;
            }
            this.functions.setSlider(key, value);
        },
        dataUrl: (src) => {
            return new Promise(function (resolve, reject) {
                // Create an Image object
                var img = new Image();
                // Add CORS approval to prevent a tainted canvas
                img.crossOrigin = 'Anonymous';
                img.onload = function () {
                    // Create an html canvas element
                    var canvas = document.createElement('CANVAS');
                    // Create a 2d context
                    var ctx = canvas.getContext('2d');
                    var dataURL;
                    // Resize the canavas to the original image dimensions
                    canvas.height = this.naturalHeight;
                    canvas.width = this.naturalWidth;
                    // Draw the image to a canvas
                    ctx.drawImage(this, 0, 0);
                    // Convert the canvas to a data url
                    dataURL = canvas.toDataURL('image/jpeg');
                    // Return the data url via callback
                    let object = {data_url: dataURL, web_url: src};
                    resolve(object);
                    // Mark the canvas to be ready for garbage
                    // collection
                    canvas = null;
                };
                // Load the image
                img.src = src;
                // make sure the load event fires for cached images too
                if (img.complete || img.complete === undefined) {
                    // Flush cache
                    img.src = 'data:image/jpeg;base64,R0lGODlhAQABAIAAAAAAAP///ywAAAAAAQABAAACAUwAOw==';
                    // Try again
                    img.src = src;
                }
            });
        },
        setAnalyzedImage: (image) => {
            return new Promise(function (resolve, reject) {
                resolve(image);
            })
        },
        analyzeScrapedImage: (value) => {
            return new Promise(function (resolve, reject) {
                dataRegister.analyzeImageLink(value.web_url).then((response) => {
                    try {
                        value.isAnalyzing = false;
                        value.isValid = response.valid;
                        value.error = response.error;
                        value.isAnalyzed = true;
                        value.web_url = response.url;
                        value.temp_label = response.label;
                        value.images = response.images;
                        resolve(value);
                    } catch (e) {}
                }, (error) => {
                    try {
                        value.isAnalyzing = false;
                        value.isValid = true;
                        value.error = false;
                        value.isAnalyzed = true;
                        resolve(value);
                    } catch (e) {}
                });
            });
        },
        next: () => {
            this.functions.setIndustry();
        },
        back: () => {
            try {
                if (this.state.scraper_data.images.length > 0) {
                    //this.props.history.push("/" + salesChannelRegister.get('market') + "/" + langRegister.lang() + "/booster/crossroad");
                    this.props.history.push("/" + salesChannelRegister.get('market') + "/" + langRegister.lang() + "/booster/options");
                } else {
                    this.props.history.push("/" + salesChannelRegister.get('market') + "/" + langRegister.lang() + "/booster/options");
                }
            } catch (e) {
                this.props.history.push("/" + salesChannelRegister.get('market') + "/" + langRegister.lang() + "/booster/options");
            }
        }
    };

    parsers = {
        tabs: (item) => {
            try {
                for (let key in this.state.tabs) {
                    if (+this.state.tabs[key].id === +item.id) {
                        this.state.tabs[key].selected = true;
                    } else {
                        this.state.tabs[key].selected = false;
                    }
                }
                this.setState({tabs: this.state.tabs});
            } catch (e) {
                console.log(e);
            }
        },
        identifier: (item) => {
            try {
                for (let key in this.state.dropdowns) {
                    if (this.state.dropdowns[key].id === "identifier" && this.state.tabs[this.state.dropdowns[key].tab_value].selected) {
                        for (let i = 0; i < this.state.dropdowns[key].selections.length; i++) {
                            if (this.state.dropdowns[key].selections[i].id === item.id) {
                                this.state.dropdowns[key].value = JSON.stringify(this.state.dropdowns[key].selections[i]);
                                break;
                            }
                        }
                    }
                }
                this.setState({dropdowns: this.state.dropdowns});
            } catch (e) {
                console.log(e);
            }
        },
        type: (item) => {
            try {
                for (let key in this.state.dropdowns) {
                    if (this.state.dropdowns[key].id === "type" && this.state.tabs[this.state.dropdowns[key].tab_value].selected) {
                        for (let i = 0; i < this.state.dropdowns[key].selections.length; i++) {
                            if (this.state.dropdowns[key].selections[i].id === item.id) {
                                this.state.dropdowns[key].value = JSON.stringify(this.state.dropdowns[key].selections[i]);
                                break;
                            }
                        }
                    }
                }
                this.setState({dropdowns: this.state.dropdowns});
            } catch (e) {
                console.log(e);
            }
        },
        beds: (item) => {
            try {
                for (let key in this.state.dropdowns) {
                    if (this.state.dropdowns[key].id === "beds" && this.state.tabs[this.state.dropdowns[key].tab_value].selected) {
                        for (let i = 0; i < this.state.dropdowns[key].selections.length; i++) {
                            if (this.state.dropdowns[key].selections[i].amount === +item) {
                                this.state.dropdowns[key].value = JSON.stringify(this.state.dropdowns[key].selections[i]);
                                break;
                            }
                        }
                    }
                }
                this.setState({dropdowns: this.state.dropdowns});
            } catch (e) {
                console.log(e);
            }
        },
        baths: (item) => {
            try {
                for (let key in this.state.dropdowns) {
                    if (this.state.dropdowns[key].id === "baths" && this.state.tabs[this.state.dropdowns[key].tab_value].selected) {
                        for (let i = 0; i < this.state.dropdowns[key].selections.length; i++) {
                            if (this.state.dropdowns[key].selections[i].amount === +item) {
                                this.state.dropdowns[key].value = JSON.stringify(this.state.dropdowns[key].selections[i]);
                                break;
                            }
                        }
                    }
                }
                this.setState({dropdowns: this.state.dropdowns});
            } catch (e) {
                console.log(e);
            }
        },
        completionStatus: (item) => {
            try {
                for (let key in this.state.dropdowns) {
                    if (this.state.dropdowns[key].id === "status" && this.state.tabs[this.state.dropdowns[key].tab_value].selected) {
                        for (let i = 0; i < this.state.dropdowns[key].selections.length; i++) {
                            if (this.state.dropdowns[key].selections[i].id === item.id) {
                                this.state.dropdowns[key].value = JSON.stringify(this.state.dropdowns[key].selections[i]);
                                break;
                            }
                        }
                    }
                }
                this.setState({dropdowns: this.state.dropdowns});
            } catch (e) {
                console.log(e);
            }
        },
        furnishings: (item) => {
            try {
                for (let key in this.state.dropdowns) {
                    if (this.state.dropdowns[key].id === "furniture" && this.state.tabs[this.state.dropdowns[key].tab_value].selected) {
                        for (let i = 0; i < this.state.dropdowns[key].selections.length; i++) {
                            if (this.state.dropdowns[key].selections[i].id === item.id) {
                                this.state.dropdowns[key].value = JSON.stringify(this.state.dropdowns[key].selections[i]);
                                break;
                            }
                        }
                    }
                }
                this.setState({dropdowns: this.state.dropdowns});
            } catch (e) {
                console.log(e);
            }
        },
        size: (item) => {
            try {
                for (let key in this.state.sliders) {
                    if (this.state.sliders[key].id === "size" && this.state.tabs[this.state.sliders[key].tab_value].selected) {
                        this.state.sliders[key].value = +item;
                        for (let key_two in this.state.sliders[key].parameters) {
                            if (key_two === "sqft") {
                                this.state.sliders[key].parameters[key_two].value = +item;
                            }
                            if (key_two === "sqm") {
                                this.state.sliders[key].parameters[key_two].value = (+item * this.state.sliders[key].parameters[key_two].rate);
                            }
                        }
                    }
                }
                this.setState({sliders: this.state.sliders});
            } catch (e) {
                console.log(e);
            }
        },
        price: (item) => {
            try {
                for (let key in this.state.sliders) {
                    if (this.state.sliders[key].id === "price" && this.state.tabs[this.state.sliders[key].tab_value].selected) {
                        this.state.sliders[key].value = +item;
                        for (let key_two in this.state.sliders[key].parameters) {
                            if (key_two === "price") {
                                this.state.sliders[key].parameters[key_two].value = +item;
                            }
                        }
                    }
                }
                this.setState({sliders: this.state.sliders});
            } catch (e) {
                console.log(e);
            }
        },
        place: (item) => {
            console.log(item);

            try {
                let scraper_data = JSON.parse(scraperRegister.get());
                let search_query = null;
                let self = this;
                let country = null;
                if(!this.state.scraper_data.additional_information.facts.address_id){
                    if(scraper_data.additional_information.facts.places.length > 1){
                        search_query = scraper_data.additional_information.facts.places[0] + " " + scraper_data.additional_information.facts.places[1]
                    }
                    try {
                        if(JSON.parse(this.state.region_grid[1].value).country_code){
                            country = JSON.parse(this.state.region_grid[1].value).country_code;
                        }else{
                            country = JSON.parse(salesChannelRegister.get("country_region")).country_code;
                        }
                    }catch (e) {}
                    if(!this.state.autocomplete_placeid && search_query){
                        this.autocomplete.getPlacePredictions({
                            input: search_query,
                            componentRestrictions: {country: country?country:'AE'}
                        }, function (predictions, status) {
                            if (status === 'OK' && predictions && predictions.length > 0) {
                                try {
                                    self.geocoder.geocode({'placeId': predictions[0].place_id}, function (results, status) {
                                        if (status === 'OK' && results && results.length > 0) {
                                            self.setState({
                                                autocomplete_lat: results[0].geometry.location.lat(),
                                                autocomplete_lng: results[0].geometry.location.lng(),
                                                autocomplete_placeid: predictions[0].place_id,
                                                autocomplete_address: predictions[0].structured_formatting.main_text,
                                                autocomplete_full_address: predictions[0].description,
                                                autocomplete_search: predictions[0].structured_formatting.main_text
                                            });
                                        }
                                    });
                                }catch (e) {}
                            }
                        });
                    }
                }else{
                    this.setState({
                        autocomplete_lat: this.state.scraper_data.additional_information.facts.address_lat,
                        autocomplete_lng: this.state.scraper_data.additional_information.facts.address_lng,
                        autocomplete_placeid: this.state.scraper_data.additional_information.facts.address_id,
                        autocomplete_address: this.state.scraper_data.additional_information.facts.address,
                        autocomplete_full_address: this.state.scraper_data.additional_information.facts.address_full,
                        autocomplete_search: this.state.scraper_data.additional_information.facts.address
                    });
                }
            }catch (e) {}

            /*
            try {
                let region_grid = {};

                let set = (target, level, last) => {

                    target = JSON.parse(JSON.stringify(target));

                    if (!region_grid[target.level]) {
                        region_grid[target.level] = {};
                    }

                    region_grid[target.level].error = false;
                    region_grid[target.level].title = "Select";
                    region_grid[target.level].level = target.level;

                    if (!region_grid[target.level].children) {
                        region_grid[target.level].children = [];
                        region_grid[target.level].children.push(target);
                    }

                    region_grid[target.level].value = JSON.stringify(target);

                    if(target.level === 1){
                        for (let i = 0; i < this.state.regions.length; i++) {
                            if (this.state.regions[i].level === target.level && this.state.regions[i].id !== target.id) {
                                region_grid[target.level].children.push(this.state.regions[i])
                            }
                        }
                    }else{
                        region_grid[target.level] = {value: "-1", children: [], title: "Select", level: target.level};

                        region_grid[target.level].value = JSON.stringify(target);

                        for (let i = 0; i < this.state.regions.length; i++) {
                            try {
                                if (this.state.regions[i].parent_id === target.parent_id && this.state.regions[i].level === target.level) {
                                    region_grid[target.level].children.push(this.state.regions[i]);
                                }
                            }catch (e) {}
                        }
                    }

                    if(last){
                        console.log(target);
                        target.level = target.level + 1;
                        region_grid[target.level] = {value: "-1", children: [], title: "Select", level: target.level};
                        for (let i = 0; i < this.state.regions.length; i++) {
                            try {
                                if (this.state.regions[i].level === target.level && target.county_id === this.state.regions[i].county_id) {
                                    region_grid[target.level].children.push(this.state.regions[i]);
                                }
                            }catch (e) {}
                        }

                        console.log(region_grid);
                    }

                };
                let keys = Object.keys(item.parents).sort().map((item) => {
                    return item
                });
                for (let i = 0; i < keys.length; i++) {
                    if(i === keys.length - 1){
                        set(item.parents[keys[i]], item.parents[keys[i]].level, true)
                    }else{
                        set(item.parents[keys[i]], item.parents[keys[i]].level, false)
                    }
                }
                this.setState({region_grid: region_grid}, () => {
                    try {
                        let scraper_data = JSON.parse(scraperRegister.get());
                        let search_query = null;
                        let self = this;
                        if(scraper_data.additional_information.facts.places.length > 1){
                            search_query = scraper_data.additional_information.facts.places[0] + " " + scraper_data.additional_information.facts.places[1]
                        }
                        if(!this.state.autocomplete_placeid && search_query){
                            this.autocomplete.getPlacePredictions({
                                input: search_query,
                                componentRestrictions: {country: JSON.parse(this.state.region_grid[1].value).country_code}
                            }, function (predictions, status) {
                                if (status === 'OK' && predictions && predictions.length > 0) {
                                    try {
                                        self.geocoder.geocode({'placeId': predictions[0].place_id}, function (results, status) {
                                            if (status === 'OK' && results && results.length > 0) {
                                                self.setState({
                                                    autocomplete_lat: results[0].geometry.location.lat(),
                                                    autocomplete_lng: results[0].geometry.location.lng(),
                                                    autocomplete_placeid: predictions[0].place_id,
                                                    autocomplete_address: predictions[0].structured_formatting.main_text,
                                                    autocomplete_full_address: predictions[0].description,
                                                    autocomplete_search: predictions[0].structured_formatting.main_text
                                                });
                                            }
                                        });
                                    }catch (e) {}
                                }
                            });
                        }
                    }catch (e) {}
                });

            } catch (e) {
                console.log(e);
            }
            */
        },
        currency: (item) => {
            try {
                for (let key in this.state.sliders) {
                    if (this.state.sliders[key].id === "price") {
                        for (let key_two in this.state.sliders[key].parameters) {
                            if (key_two === "currency") {
                                this.state.sliders[key].parameters[key_two].value = item.toUpperCase();
                            }
                        }
                    }
                }
                this.setState({sliders: this.state.sliders});
            } catch (e) {
                console.log(e);
            }
        },
        duration: (item) => {
            try {
                if (item) {
                    for (let key in this.state.sliders) {
                        if (this.state.sliders[key].id === "price" && this.state.tabs[this.state.sliders[key].tab_value].selected) {
                            this.state.sliders[key].step = item.step;
                            this.state.sliders[key].max = item.max;
                            for (let key_two in this.state.sliders[key].parameters) {
                                if (key_two === "time") {
                                    this.state.sliders[key].parameters[key_two].value = JSON.stringify(item);
                                }
                            }
                        }
                    }
                    this.setState({sliders: this.state.sliders});
                }
            } catch (e) {
                console.log(e);
            }
        },
        amenities: (items) => {
            try {
                for (let key in this.state.amenities) {
                    for (let i = 0; i < items.length; i++) {
                        if (this.state.amenities[key].id === items[i].id) {
                            this.state.amenities[key].selected = items[i].selected;
                        }
                    }
                }
                this.setState({amenities: this.state.amenities});
            } catch (e) {
                console.log(e);
            }
        },
        industries: (items) => {
            try {
                let parsed_industries = [];
                for (let i = 0; i < items.length; i++) {
                    if (items[i].saleschannel_owner) {
                        parsed_industries.push(items[i]);
                    }
                }
                if (parsed_industries.length > 0) {
                    this.setState({industries: parsed_industries}, () => {
                        industriesRegister.set(this.state.industries);
                        this.update.regions();
                    });
                } else {

                    //LOGIN USER OR ERROR
                    this.props.history.push("/" + salesChannelRegister.get('market') + "/" + langRegister.lang());

                }
            } catch (e) {
                this.setState({error: true, isLoading: false}, () => {
                    console.log(e);
                });
            }
        },
        regions: (items, level) => {

            //SET DISPLAY REGION
            let display_region = null;
            let cart = cartRegister.get();
            let contry_region = JSON.parse(salesChannelRegister.get("country_region"));
            try {
                if(cart.display_region){
                    display_region = cart.display_region.id;
                }else{
                    display_region = contry_region.id;
                    cartRegister.setDisplayRegion(JSON.parse(salesChannelRegister.get("country_region")));
                }
            }catch (e) {}

            if (Object.keys(this.state.region_grid).length < 1) {
                let contry_region_select = null;
                let scraper_data = JSON.parse(scraperRegister.get());
                try {
                    if(scraper_data.additional_information.facts.places){
                        let region = null;
                        let value = scraper_data.additional_information.facts.places[0];
                        for (let i = 0; i < items.length; i++) {
                            if(items[i].name.toLowerCase() === value.toLowerCase()){
                                region = items[i];
                            }
                        };
                        if(region){
                            this.state.region_grid[region.level] = {value: JSON.stringify(region), children: [], title: "Select Country", level: region.level};
                            if(region){
                                this.state.region_grid[region.level] = {value: JSON.stringify(region), children: [], title: "Select Country", level: region.level};
                                for (let i = 0; i < items.length; i++) {
                                    if (items[i].level === region.level && items[i].country_code === region.country_code) {
                                        this.state.region_grid[region.level].children.push(items[i])
                                    }
                                }
                            }
                            let parent = region.parent_id;
                            if(parent){
                                region = findParent(parent);
                                if(region){
                                    this.state.region_grid[region.level] = {value: JSON.stringify(region), children: [], title: "Select Country", level: region.level};
                                    for (let i = 0; i < items.length; i++) {
                                        if (items[i].level === region.level && items[i].country_code === region.country_code) {
                                            this.state.region_grid[region.level].children.push(items[i])
                                        }
                                    }
                                }
                                parent = region.parent_id;
                            }
                            if(parent){
                                region = findParent(parent);
                                if(region){
                                    this.state.region_grid[region.level] = {value: JSON.stringify(region), children: [], title: "Select Country", level: region.level};
                                    for (let i = 0; i < items.length; i++) {
                                        if (items[i].level === region.level && items[i].country_code === region.country_code) {
                                            this.state.region_grid[region.level].children.push(items[i])
                                        }
                                    }
                                }
                                parent = region.parent_id;
                            }
                            if(parent){
                                region = findParent(parent);
                                if(region){
                                    this.state.region_grid[region.level] = {value: JSON.stringify(region), children: [], title: "Select Country", level: region.level};
                                    for (let i = 0; i < items.length; i++) {
                                        if (items[i].level === region.level && items[i].country_code === region.country_code) {
                                            this.state.region_grid[region.level].children.push(items[i])
                                        }
                                    }
                                }
                                parent = region.parent_id;
                            }
                            if(parent){
                                region = findParent(parent);
                                if(region){
                                    this.state.region_grid[region.level] = {value: JSON.stringify(region), children: [], title: "Select Country", level: region.level};
                                    for (let i = 0; i < items.length; i++) {
                                        if (items[i].level === region.level && items[i].country_code === region.country_code) {
                                            this.state.region_grid[region.level].children.push(items[i])
                                        }
                                    }
                                }
                                parent = region.parent_id;
                            }
                            if(parent){
                                region = findParent(parent);
                                if(region){
                                    this.state.region_grid[region.level] = {value: JSON.stringify(region), children: [], title: "Select Country", level: region.level};
                                    for (let i = 0; i < items.length; i++) {
                                        if (items[i].level === region.level && items[i].country_code === region.country_code) {
                                            this.state.region_grid[region.level].children.push(items[i])
                                        }
                                    }
                                }
                                parent = region.parent_id;
                            }

                            console.log(this.state.region_grid);

                            let lowest = 1;
                            for(let key in this.state.region_grid){
                                if(lowest < key){
                                    lowest = key;
                                }
                            }

                            this.setState({region_grid: this.state.region_grid, display_region: display_region}, () => {
                                this.functions.setRegion(this.state.region_grid[lowest].value, lowest, true);
                            });

                        }
                    }
                }catch (e) {}
                if (Object.keys(this.state.region_grid).length < 1) {
                    try {
                        this.state.region_grid[1] = {value: "-1", children: [], title: "Select Country", level: level};
                        for (let i = 0; i < items.length; i++) {
                            if (items[i].level === 1) {
                                this.state.region_grid[1].children.push(items[i])
                            }
                            if(contry_region.id === items[i].id){
                                contry_region_select = items[i];
                            }
                        }
                    } catch (e) {}
                    this.setState({region_grid: this.state.region_grid, display_region: display_region}, () => {
                        if(contry_region_select){
                            this.functions.setRegion(JSON.stringify(contry_region_select), 1, true);
                        }
                    });
                };
            } else {
                this.setState({display_region: display_region}, () => {
                    this.update.data();
                });
            }

            function findParent(item) {
                let value = null;
                for (let i = 0; i < items.length; i++) {
                    if(items[i].id === item){
                        value = items[i];
                        break;
                    }
                };
                return value;
            }

        },
        discounts: (item) => {
            try {
                for (let key in this.state.dropdowns) {
                    if (this.state.dropdowns[key].id === "discount" && this.state.tabs[this.state.dropdowns[key].tab_value].selected) {
                        for (let i = 0; i < this.state.dropdowns[key].selections.length; i++) {
                            if (this.state.dropdowns[key].selections[i].id === item.id) {
                                this.state.dropdowns[key].value = JSON.stringify(this.state.dropdowns[key].selections[i]);
                                break;
                            }
                        }
                    }
                }
                this.setState({dropdowns: this.state.dropdowns}, () => {});
            } catch (e) {
                console.log(e);
            }
        },
        dldwaivers: (item) => {
            try {
                for (let key in this.state.dropdowns) {
                    if (this.state.dropdowns[key].id === "dldwaiver" && this.state.tabs[this.state.dropdowns[key].tab_value].selected) {
                        for (let i = 0; i < this.state.dropdowns[key].selections.length; i++) {
                            if (this.state.dropdowns[key].selections[i].id === item.id) {
                                this.state.dropdowns[key].value = JSON.stringify(this.state.dropdowns[key].selections[i]);
                                break;
                            }
                        }
                    }
                }
                this.setState({dropdowns: this.state.dropdowns});
            } catch (e) {
                console.log(e);
            }
        },
        downpayments: (item) => {
            try {
                for (let key in this.state.dropdowns) {
                    if (this.state.dropdowns[key].id === "downpayment" && this.state.tabs[this.state.dropdowns[key].tab_value].selected) {
                        for (let i = 0; i < this.state.dropdowns[key].selections.length; i++) {
                            if (this.state.dropdowns[key].selections[i].id === item.id) {
                                this.state.dropdowns[key].value = JSON.stringify(this.state.dropdowns[key].selections[i]);
                                break;
                            }
                        }
                    }
                }
                this.setState({dropdowns: this.state.dropdowns});
            } catch (e) {
                console.log(e);
            }
        },
        finance: (item) => {
            try {
                for (let key in this.state.dropdowns) {
                    if (this.state.dropdowns[key].id === "finance" && this.state.tabs[this.state.dropdowns[key].tab_value].selected) {
                        for (let i = 0; i < this.state.dropdowns[key].selections.length; i++) {
                            if (this.state.dropdowns[key].selections[i].id === item.id) {
                                this.state.dropdowns[key].value = JSON.stringify(this.state.dropdowns[key].selections[i]);
                                break;
                            }
                        }
                    }
                }
                this.setState({dropdowns: this.state.dropdowns});
            } catch (e) {
                console.log(e);
            }
        },
        paymentplans: (item) => {
            try {
                for (let key in this.state.dropdowns) {
                    if (this.state.dropdowns[key].id === "paymentplan" && this.state.tabs[this.state.dropdowns[key].tab_value].selected) {
                        for (let i = 0; i < this.state.dropdowns[key].selections.length; i++) {
                            if (this.state.dropdowns[key].selections[i].id === item.id) {
                                this.state.dropdowns[key].value = JSON.stringify(this.state.dropdowns[key].selections[i]);
                                break;
                            }
                        }
                    }
                }
                this.setState({dropdowns: this.state.dropdowns});
            } catch (e) {
                console.log(e);
            }
        },
        servicecharges: (item) => {
            try {
                for (let key in this.state.dropdowns) {
                    if (this.state.dropdowns[key].id === "servicecharge" && this.state.tabs[this.state.dropdowns[key].tab_value].selected) {
                        for (let i = 0; i < this.state.dropdowns[key].selections.length; i++) {
                            if (this.state.dropdowns[key].selections[i].id === item.id) {
                                this.state.dropdowns[key].value = JSON.stringify(this.state.dropdowns[key].selections[i]);
                                break;
                            }
                        }
                    }
                }
                this.setState({dropdowns: this.state.dropdowns});
            } catch (e) {
                console.log(e);
            }
        },
        cheques: (item) => {
            try {
                for (let key in this.state.dropdowns) {
                    if (this.state.dropdowns[key].id === "cheques" && this.state.tabs[this.state.dropdowns[key].tab_value].selected) {
                        for (let i = 0; i < this.state.dropdowns[key].selections.length; i++) {
                            if (this.state.dropdowns[key].selections[i].id === item.id) {
                                this.state.dropdowns[key].value = JSON.stringify(this.state.dropdowns[key].selections[i]);
                                break;
                            }
                        }
                    }
                }
                this.setState({dropdowns: this.state.dropdowns});
            } catch (e) {
                console.log(e);
            }
        },
        freemonths: (item) => {
            try {
                for (let key in this.state.dropdowns) {
                    if (this.state.dropdowns[key].id === "freemonths" && this.state.tabs[this.state.dropdowns[key].tab_value].selected) {
                        for (let i = 0; i < this.state.dropdowns[key].selections.length; i++) {
                            if (this.state.dropdowns[key].selections[i].id === item.id) {
                                this.state.dropdowns[key].value = JSON.stringify(this.state.dropdowns[key].selections[i]);
                                break;
                            }
                        }
                    }
                }
                this.setState({dropdowns: this.state.dropdowns});
            } catch (e) {
                console.log(e);
            }
        },
        roi: (item) => {
            try {
                for (let key in this.state.dropdowns) {
                    if (this.state.dropdowns[key].id === "roi" && this.state.tabs[this.state.dropdowns[key].tab_value].selected) {
                        for (let i = 0; i < this.state.dropdowns[key].selections.length; i++) {
                            if (this.state.dropdowns[key].selections[i].id === item.id) {
                                this.state.dropdowns[key].value = JSON.stringify(this.state.dropdowns[key].selections[i]);
                                break;
                            }
                        }
                    }
                }
                this.setState({dropdowns: this.state.dropdowns});
            } catch (e) {
                console.log(e);
            }
        }
    };

    renders = {
        text: (item) => {
            return langRegister.get("booster-industry", item);
        },
        dropdownValue: (item) => {
            try {
                return JSON.parse(item).title
            } catch (e) {
                return null;
            }
        },
        regionDropdownValue: (item) => {
            try {
                return JSON.parse(item).name
            } catch (e) {
                return null;
            }
        },
        regionDropdownId: (item) => {
            try {
                return JSON.parse(item).id
            } catch (e) {
                return null;
            }
        },
        numbers: (value) => {
            try {
                value = Math.round(value * 100) / 100;
                return value.toString().replace(/\B(?=(\d{3})+(?!\d))/g, " ");
            } catch (e) {
                return (0)
            }
        },
        amenities: (items) => {
            try {
                let array = [];
                for (let key in items) {
                    array.push(items[key]);
                }
                array.sort(function (a, b) {
                    var at = a.title,
                        bt = b.title;
                    return at > bt ? 1 : (at < bt ? -1 : 0);
                });
                return array
            } catch (e) {}
        },
        price: (value) => {
            let price = 0;
            try {
                for (let key in this.state.sliders) {
                    if (this.state.sliders[key].id === "price" && this.state.tabs[this.state.sliders[key].tab_value].selected) {
                        price = this.state.sliders[key].value;
                        break;
                    }
                }
                if(Math.round(price * JSON.parse(value).rate) > 0){
                    return this.renders.numbers(Math.round(price * JSON.parse(value).rate)) + " ";
                }
            }catch (e) {

            }
        },
        backButton: () => {
            try {
                return this.state.scraper_data.images.length > 0
            } catch (e) {
                return false;
            }
        }
    };

    _renderHandle(props) {
        const {value, impressions, titleTwo, dragging, index, budget, currency, title, min, max, ...restProps} = props;
        return (<Handle value={value} {...restProps} />);
    }

    render() {
        return (
            <div>
                <BoosterHeader props={this.props}/>
                {
                    !this.state.isLoading &&
                    <div className={Styles.container}>
                        <div className={Styles.title}>
                            <div>
                                {this.renders.text("item_1")}
                            </div>
                        </div>
                        <div className={Styles.optionsContainer}>
                            <div className={cx(Styles.tabsContainer)}>
                                {
                                    Object.keys(this.state.tabs).map((key) => {
                                        return (
                                            <div onClick={() => this.functions.setTab(key, true)} className={
                                                cx(Styles.tabsContainerItem,
                                                    {
                                                        [Styles.tabsContainerItemActive]: this.state.tabs[key].selected,
                                                    })
                                            }>
                                                {this.state.tabs[key].title}
                                            </div>
                                        )
                                    })
                                }
                            </div>
                            <div className={Styles.dropdownsContainer}>
                                {
                                    Object.keys(this.state.dropdowns).filter((key) => {
                                        return this.state.tabs[this.state.dropdowns[key].tab_value].selected && !this.state.dropdowns[key].extra && !this.state.dropdowns[key].currency
                                    }).map((key) => {
                                        return (
                                            <div className={
                                                cx(Styles.dropdown,
                                                    {
                                                        [Styles.dropdownError]: this.state.dropdowns[key].error,
                                                        [Styles.dropdownDisabled]: this.state.dropdowns[key].disabled,
                                                        /*[Styles.dropdownSelected]: !this.state.dropdowns[key].disabled && this.renders.dropdownValue(this.state.dropdowns[key].value),*/
                                                    })
                                            }>
                                                <select
                                                    value={this.state.dropdowns[key].value}
                                                    disabled={this.state.dropdowns[key].disabled}
                                                    className={Styles.dropdownSelection}
                                                    onChange={(event) => this.functions.setDropdown(key, event.target.value)}
                                                >
                                                    <option value="-1">{this.state.dropdowns[key].title}</option>
                                                    {
                                                        this.state.dropdowns[key].selections.map((item) => {
                                                            return (
                                                                <option className={Styles.dropdownSelectionOption}
                                                                        value={JSON.stringify(item)}>{item.title}</option>
                                                            )
                                                        })
                                                    }
                                                </select>
                                                {
                                                    this.renders.dropdownValue(this.state.dropdowns[key].value) &&
                                                    <div
                                                        className={Styles.dropdownText}>{this.renders.dropdownValue(this.state.dropdowns[key].value)}</div>
                                                }
                                                {
                                                    this.renders.dropdownValue(this.state.dropdowns[key].value) && !this.state.dropdowns[key].disabled && false &&
                                                    <img onClick={() => {
                                                        this.state.dropdowns[key].value = '-1';
                                                        this.setState({dropdowns: this.state.dropdowns});
                                                    }} className={Styles.dropdownRemove}
                                                         src={require("../../assets/images/close_icon_white_2.svg")}/>
                                                }
                                                {
                                                    !this.renders.dropdownValue(this.state.dropdowns[key].value) &&
                                                    <div
                                                        className={Styles.dropdownText}>{this.state.dropdowns[key].title}</div>
                                                }
                                                {
                                                    !this.state.dropdowns[key].error && !this.state.dropdowns[key].disabled &&
                                                    <img className={Styles.dropdownArrow}
                                                         src={require("../../assets/images/arrow-down.svg")}/>
                                                }
                                                {
                                                    this.state.dropdowns[key].error && !this.state.dropdowns[key].disabled &&
                                                    <img className={Styles.dropdownArrow}
                                                         src={require("../../assets/images/arrow-down-error.svg")}/>
                                                }
                                                {
                                                    this.state.dropdowns[key].disabled &&
                                                    <img className={Styles.dropdownArrow}
                                                         src={require("../../assets/images/arrow-down-disabled.svg")}/>
                                                }
                                            </div>
                                        )
                                    })
                                }
                            </div>
                            <div className={Styles.slidersContainer}>
                                {
                                    Object.keys(this.state.sliders).filter((key) => {
                                        return this.state.tabs[this.state.sliders[key].tab_value].selected
                                    }).map((key) => {
                                        return (
                                            <div className={Styles.slider}>
                                                <div className={Styles.sliderTitle}>
                                                    {this.state.sliders[key].title}
                                                </div>
                                                <div className={Styles.sliderInner}>
                                                    <div className={Styles.sliderInnerContainer}>
                                                        <div onClick={() => this.functions.decreaseSlider(key)}
                                                             className={Styles.sliderInnerContainerCircle}>
                                                            <img className={Styles.sliderInnerContainerCircleMinus}
                                                                 src={require("../../assets/images/minus_icon_white_small.png")}/>
                                                        </div>
                                                        <div className={Styles.sliderInnerContainerInner}>
                                                            <Slider
                                                                index={1}
                                                                step={this.state.sliders[key].step}
                                                                min={this.state.sliders[key].min}
                                                                max={this.state.sliders[key].max}
                                                                title={"title"}
                                                                titleTwo={"title"}
                                                                value={this.state.sliders[key].value}
                                                                onChange={(value) => this.functions.setSlider(key, value)}
                                                                handle={this._renderHandle}
                                                            />
                                                        </div>
                                                        <div onClick={() => this.functions.increaseSlider(key)}
                                                             className={cx(Styles.sliderInnerContainerCircle, Styles.sliderInnerContainerCircleRight)}>
                                                            <img className={Styles.sliderInnerContainerCirclePlus}
                                                                 src={require("../../assets/images/plus_sign_white_small.png")}/>
                                                        </div>
                                                        <div className={Styles.sliderInnerContainerInnerRail}/>
                                                        <div className={Styles.sliderInnerContainerInnerRailLeft}/>
                                                    </div>
                                                    <div className={Styles.sliderInnerBoxes}>
                                                        {
                                                            Object.keys(this.state.sliders[key].parameters).map((key_two, index) => {
                                                                return (
                                                                    <div className={Styles.sliderValueContainer}>
                                                                        {
                                                                            this.state.sliders[key].parameters[key_two].type === "input" &&
                                                                            <div className={
                                                                                cx(Styles.sliderValue,
                                                                                    {
                                                                                        [Styles.sliderValueLong]: this.state.sliders[key].parameters[key_two].style_long,
                                                                                    })
                                                                            }>
                                                                                {
                                                                                    (key_two === "currency") &&
                                                                                    <div
                                                                                        className={Styles.sliderValueText}>
                                                                                        {this.state.sliders[key].parameters[key_two].value}
                                                                                    </div>
                                                                                }
                                                                                {
                                                                                    (key_two === "price") && this.state.sliders[key].parameters[key_two].value > 0 &&
                                                                                    <div
                                                                                        className={Styles.sliderValueText}>
                                                                                        {this.renders.numbers(this.state.sliders[key].parameters[key_two].value)}
                                                                                    </div>
                                                                                }
                                                                                {
                                                                                    (key_two === "price") && this.state.sliders[key].parameters[key_two].value < 1 &&
                                                                                    <div className={Styles.sliderValueText}>
                                                                                        On request
                                                                                    </div>
                                                                                }
                                                                                {
                                                                                    key_two !== "price" && key_two !== "currency" &&
                                                                                    <div
                                                                                        className={Styles.sliderValueText}>
                                                                                        {this.renders.numbers(this.state.sliders[key].parameters[key_two].value)}{" "}{this.state.sliders[key].parameters[key_two].title}
                                                                                    </div>
                                                                                }
                                                                            </div>
                                                                        }
                                                                        {
                                                                            this.state.sliders[key].parameters[key_two].type === "dropdown" &&
                                                                            <div className={
                                                                                cx(Styles.sliderValueDropdown,
                                                                                    {
                                                                                        [Styles.sliderValueDropdownLong]: this.state.sliders[key].parameters[key_two].style_long,
                                                                                        [Styles.sliderValueDropdownError]: this.state.sliders[key].parameters[key_two].error,
                                                                                        [Styles.sliderValueDropdownExtra]: this.state.sliders[key].parameters[key_two].under,
                                                                                    })
                                                                            }>
                                                                                <select
                                                                                    value={this.state.sliders[key].parameters[key_two].value}
                                                                                    className={Styles.sliderValueDropdownSelection}
                                                                                    onChange={(event) => this.functions.setSliderDropdown(key, key_two, event.target.value)}>
                                                                                    <option value="-1" disabled>Select{" "}{this.state.sliders[key].parameters[key_two].title}</option>
                                                                                    {
                                                                                        this.state.sliders[key].parameters[key_two].selections.map((item) => {
                                                                                            return (
                                                                                                <option
                                                                                                    value={JSON.stringify(item)}>{item.title}</option>
                                                                                            )
                                                                                        })
                                                                                    }
                                                                                </select>
                                                                                {
                                                                                    this.renders.dropdownValue(this.state.sliders[key].parameters[key_two].value) &&
                                                                                    <div
                                                                                        className={Styles.sliderValueDropdownText}>{this.renders.dropdownValue(this.state.sliders[key].parameters[key_two].value)}</div>
                                                                                }
                                                                                {
                                                                                    !this.renders.dropdownValue(this.state.sliders[key].parameters[key_two].value) &&
                                                                                    <div
                                                                                        className={Styles.sliderValueDropdownText}>{this.state.sliders[key].parameters[key_two].title}</div>
                                                                                }
                                                                                {
                                                                                    !this.state.sliders[key].parameters[key_two].error &&
                                                                                    <img
                                                                                        className={Styles.sliderValueDropdownArrow}
                                                                                        src={require("../../assets/images/arrow-down.svg")}/>
                                                                                }
                                                                                {
                                                                                    this.state.sliders[key].parameters[key_two].error &&
                                                                                    <img
                                                                                        className={Styles.sliderValueDropdownArrow}
                                                                                        src={require("../../assets/images/arrow-down-error.svg")}/>
                                                                                }
                                                                            </div>
                                                                        }
                                                                        {
                                                                            Object.keys(this.state.sliders[key].parameters).length > 1 &&
                                                                            index === 0 &&
                                                                            <div
                                                                                className={cx(Styles.sliderValueDivider)}>
                                                                                /
                                                                            </div>
                                                                        }
                                                                    </div>
                                                                )
                                                            })
                                                        }
                                                    </div>
                                                </div>
                                            </div>
                                        )
                                    })
                                }
                            </div>
                            <div className={Styles.currencyContainer}>
                                <div className={Styles.currencyContainerTitle}>
                                    {this.renders.text("item_2")}
                                </div>
                                {
                                    Object.keys(this.state.dropdowns).filter((key) => {
                                        return this.state.tabs[this.state.dropdowns[key].tab_value].selected && this.state.dropdowns[key].currency
                                    }).map((key) => {
                                        return (
                                            <div className={
                                                cx(Styles.dropdown,
                                                    {
                                                        [Styles.dropdownError]: this.state.dropdowns[key].error,
                                                        //[Styles.dropdownSelected]: this.renders.dropdownValue(this.state.dropdowns[key].value),
                                                    })
                                            }>
                                                <select
                                                    value={this.state.dropdowns[key].value}
                                                    //disabled={this.renders.dropdownValue(this.state.dropdowns[key].value)}
                                                    className={Styles.dropdownSelection}
                                                    onChange={(event) => this.functions.setDropdown(key, event.target.value)}
                                                >
                                                    <option value="-1">{this.state.dropdowns[key].title}</option>
                                                    {
                                                        this.state.dropdowns[key].selections.map((item) => {
                                                            return (
                                                                <option className={Styles.dropdownSelectionOption}
                                                                        value={JSON.stringify(item)}>{item.title}</option>
                                                            )
                                                        })
                                                    }
                                                </select>
                                                {
                                                    this.renders.dropdownValue(this.state.dropdowns[key].value) &&
                                                    <div
                                                        className={Styles.dropdownText}>{this.renders.price(this.state.dropdowns[key].value)}{this.renders.dropdownValue(this.state.dropdowns[key].value)}</div>
                                                }
                                                {
                                                    !this.renders.dropdownValue(this.state.dropdowns[key].value) &&
                                                    <div
                                                        className={Styles.dropdownText}>{this.state.dropdowns[key].title}</div>
                                                }
                                                {
                                                    this.renders.dropdownValue(this.state.dropdowns[key].value) && false &&
                                                    <img onClick={() => {
                                                        this.state.dropdowns[key].value = '-1';
                                                        this.setState({dropdowns: this.state.dropdowns});
                                                    }} className={Styles.dropdownRemove}
                                                         src={require("../../assets/images/close_icon_white_2.svg")}/>
                                                }
                                                {
                                                    !this.state.dropdowns[key].error &&
                                                    <img className={Styles.dropdownArrow}
                                                         src={require("../../assets/images/arrow-down.svg")}/>
                                                }
                                                {
                                                    this.state.dropdowns[key].error &&
                                                    <img className={Styles.dropdownArrow}
                                                         src={require("../../assets/images/arrow-down-error.svg")}/>
                                                }
                                            </div>
                                        )
                                    })
                                }
                            </div>
                            <div className={Styles.currencyContainer}>
                                <div className={Styles.currencyContainerTitle}>
                                    {this.renders.text("item_3")}
                                </div>
                                <div className={Styles.addressContainer}>
                                    <input type={'text'}
                                           autoComplete={false}
                                           onFocus={() => {
                                               this.setState({autocomplete_dropdown: true})
                                           }}
                                           onBlur={() => {
                                               this.setState({autocomplete_dropdown: false})
                                           }}
                                           value={this.state.autocomplete_search}
                                           placeholder={"Search.."}
                                           onChange={(event) => {
                                               this.setState({autocomplete_search: event.target.value}, () => {
                                                   if (this.state.autocomplete_search !== this.state.autocomplete_address) {
                                                       this.setState({autocomplete_placeid: null, autocomplete_address: null, autocomplete_full_address: null});
                                                   }
                                                   if (this.state.autocomplete_search && this.state.autocomplete_search !== "") {
                                                       let region = null;
                                                       try {
                                                           region = JSON.parse(this.state.region_grid[1].value).country_code;
                                                       } catch (e) {
                                                           region = null;
                                                       }
                                                       this.setState({autocomplete_dropdown: true}, () => {
                                                           let auto_this = this;
                                                           this.autocomplete.getPlacePredictions({
                                                               input: this.state.autocomplete_search,
                                                               componentRestrictions: {country: region?region:''}
                                                           }, function (predictions, status) {
                                                               if (status === 'OK' && predictions && predictions.length > 0) {
                                                                   auto_this.setState({autocomplete_predictions: predictions});
                                                               } else {
                                                                   auto_this.setState({
                                                                       autocomplete_dropdown: false,
                                                                       autocomplete_predictions: []
                                                                   })
                                                               }
                                                           });
                                                       })
                                                   } else {
                                                       this.setState({
                                                           autocomplete_dropdown: false,
                                                           autocomplete_predictions: []
                                                       })
                                                   }
                                               })
                                           }}
                                           className={
                                               cx(Styles.addressContainerInput,
                                                   {
                                                       [Styles.addressContainerInputError]: this.state.autocomplete_error,
                                                       //[Styles.dropdownDisabled]: this.state.region_grid[key].level === 1,
                                                       //[Styles.dropdownSelected]: this.renders.regionDropdownValue(this.state.region_grid[key].value),
                                                   })
                                           }
                                    />
                                    {
                                        this.state.autocomplete_dropdown && this.state.autocomplete_predictions.length > 0 &&
                                        <div className={Styles.addressContainerDropdown}>
                                            {
                                                this.state.autocomplete_predictions.map((item) => {
                                                    return (
                                                        <div onMouseDown={() => {
                                                            let google_this = this;
                                                            this.geocoder.geocode({'placeId': item.place_id}, function (results, status) {
                                                                if (status === 'OK' && results && results.length > 0) {
                                                                    try {
                                                                        google_this.setState({
                                                                            autocomplete_lat: results[0].geometry.location.lat(),
                                                                            autocomplete_lng: results[0].geometry.location.lng(),
                                                                            autocomplete_placeid: item.place_id,
                                                                            autocomplete_full_address: item.description,
                                                                            autocomplete_search: item.structured_formatting.main_text,
                                                                            autocomplete_address: item.structured_formatting.main_text,
                                                                            autocomplete_error: false
                                                                        });
                                                                    } catch (e) {

                                                                    }
                                                                } else {

                                                                }
                                                            });
                                                        }} className={Styles.addressContainerDropdownItem}>
                                                            {item.structured_formatting.main_text}
                                                        </div>
                                                    )
                                                })
                                            }
                                        </div>
                                    }
                                </div>
                            </div>
                            <div className={Styles.currencyContainer}>
                                <div className={Styles.currencyContainerTitle}>
                                    {this.renders.text("item_4")}
                                </div>
                                {
                                    Object.keys(this.state.region_grid).map((key, index) => {
                                        if(this.state.region_grid[key].children.length > 0){
                                            return (
                                                <div className={Styles.dropdownWrapper}>
                                                    <div onClick={() => {this.setState({display_region: this.renders.regionDropdownId(this.state.region_grid[key].value)}); cartRegister.setDisplayRegion(JSON.parse(this.state.region_grid[key].value))}} className={Styles.dropdownRadio}>
                                                        {
                                                            (this.renders.regionDropdownId(this.state.region_grid[key].value) !== this.state.display_region) && this.renders.regionDropdownId(this.state.region_grid[key].value) &&
                                                            <div className={Styles.dropdownRadioButton}></div>
                                                        }
                                                        {
                                                            this.renders.regionDropdownId(this.state.region_grid[key].value) === this.state.display_region && this.renders.regionDropdownId(this.state.region_grid[key].value) &&
                                                            <div className={Styles.dropdownRadioButtonSelected}>
                                                                <div className={Styles.dropdownRadioButtonSelectedCenter}></div>
                                                            </div>
                                                        }
                                                    </div>
                                                    <div className={
                                                        cx(Styles.dropdown, Styles.dropdownFlex,
                                                            {
                                                                [Styles.dropdownError]: this.state.region_grid[key].error,
                                                                [Styles.dropdownFlexLast]: Object.keys(this.state.region_grid).length - 1 === index,
                                                                [Styles.dropdownDisabled]: this.state.region_grid[key].level === 1 && !this.state.inhouse,
                                                                //[Styles.dropdownSelected]: this.renders.regionDropdownValue(this.state.region_grid[key].value),
                                                            })
                                                    }>
                                                        <select
                                                            value={this.state.region_grid[key].value}
                                                            className={Styles.dropdownSelection}
                                                            disabled={this.state.region_grid[key].level === 1 && !this.state.inhouse}
                                                            onChange={(event) => this.functions.setRegion(event.target.value, key)}
                                                        >
                                                            <option value="-1" disabled>Select</option>
                                                            {
                                                                this.state.region_grid[key].children.sort(function (a, b) {
                                                                    if (a.name < b.name) {
                                                                        return -1;
                                                                    }
                                                                    if (a.name > b.name) {
                                                                        return 1;
                                                                    }
                                                                    return 0;
                                                                }).map((item) => {
                                                                    return (
                                                                        <option className={Styles.dropdownSelectionOption} value={JSON.stringify(item)}>{item.name}</option>
                                                                    )
                                                                })
                                                            }
                                                        </select>
                                                        {
                                                            this.renders.regionDropdownValue(this.state.region_grid[key].value) &&
                                                            <div
                                                                className={Styles.dropdownText}>{this.renders.regionDropdownValue(this.state.region_grid[key].value)}</div>
                                                        }
                                                        {
                                                            !this.renders.regionDropdownValue(this.state.region_grid[key].value) && this.state.region_grid[key].value !== "-1" &&
                                                            <div
                                                                className={Styles.dropdownText}>{this.state.region_grid[key].title}</div>
                                                        }
                                                        {
                                                            this.renders.regionDropdownValue(this.state.region_grid[key].value) && this.state.region_grid[key].level !== 1 && false &&
                                                            <img onClick={() => {
                                                                this.functions.setRegion('-1', key)
                                                            }} className={Styles.dropdownRemove}
                                                                 src={require("../../assets/images/close_icon_white_2.svg")}/>
                                                        }
                                                        {
                                                            this.state.region_grid[key].value === "-1" &&
                                                            <div className={Styles.dropdownText}>{"Select"}</div>
                                                        }
                                                        {
                                                            (!this.state.region_grid[key].error && !(this.state.region_grid[key].level === 1 && !this.state.inhouse)) &&
                                                            <img className={Styles.dropdownArrow}
                                                                 src={require("../../assets/images/arrow-down.svg")}/>
                                                        }
                                                        {
                                                            this.state.region_grid[key].error &&
                                                            <img className={Styles.dropdownArrow}
                                                                 src={require("../../assets/images/arrow-down-error.svg")}/>
                                                        }
                                                        {
                                                            this.state.region_grid[key].level === 1 && !this.state.inhouse &&
                                                            <img className={Styles.dropdownArrow}
                                                                 src={require("../../assets/images/arrow-down-disabled.svg")}/>
                                                        }
                                                    </div>
                                                </div>
                                            )
                                        }
                                    })
                                }
                            </div>


                            <div className={Styles.amenitiesContainer}>
                                <div className={Styles.amenitiesContainerTitle}>
                                    {this.renders.text("item_5")}
                                </div>
                                <div className={Styles.amenitiesContainerInner}>
                                    {
                                        this.renders.amenities(this.state.amenities).map((item, i) => {
                                            return (
                                                <div key={i} className={Styles.amenitiesContainerItem}>
                                                    {
                                                        !item.selected &&
                                                        <img onClick={() => this.functions.setAmenity(item.id, true)}
                                                             src={require("../../assets/images/checkmark_new.svg")}
                                                             className={Styles.amenitiesContainerItemIcon}/>
                                                    }
                                                    {
                                                        item.selected &&
                                                        <img onClick={() => this.functions.setAmenity(item.id, false)}
                                                             src={require("../../assets/images/square_checkmark_active.svg")}
                                                             className={Styles.amenitiesContainerItemIcon}/>
                                                    }
                                                    <div onClick={() => {
                                                        if (item.selected) {
                                                            this.functions.setAmenity(item.id, false)
                                                        } else {
                                                            this.functions.setAmenity(item.id, true)
                                                        }
                                                    }} className={Styles.amenitiesContainerItemText}>
                                                        {item.title}
                                                    </div>
                                                </div>
                                            )
                                        })
                                    }
                                </div>
                            </div>
                            <div className={Styles.extraContainer}>
                                <div className={Styles.extraContainerTitle}>
                                    {this.renders.text("item_6")}
                                </div>
                                {
                                    Object.keys(this.state.dropdowns).filter((key) => {
                                        return this.state.tabs[this.state.dropdowns[key].tab_value].selected && this.state.dropdowns[key].extra
                                    }).map((key) => {
                                        return (
                                            <div className={
                                                cx(Styles.dropdown,
                                                    {
                                                        [Styles.dropdownError]: this.state.dropdowns[key].error,
                                                        //[Styles.dropdownSelected]: this.renders.dropdownValue(this.state.dropdowns[key].value),
                                                    })
                                            }>
                                                <select
                                                    value={this.state.dropdowns[key].value}
                                                    //disabled={this.renders.dropdownValue(this.state.dropdowns[key].value)}
                                                    className={Styles.dropdownSelection}
                                                    onChange={(event) => this.functions.setDropdown(key, event.target.value)}
                                                >
                                                    <option value="-1">{this.state.dropdowns[key].title}</option>
                                                    {
                                                        this.state.dropdowns[key].selections.map((item) => {
                                                            return (
                                                                <option className={Styles.dropdownSelectionOption}
                                                                        value={JSON.stringify(item)}>{item.title}</option>
                                                            )
                                                        })
                                                    }
                                                </select>
                                                {
                                                    this.renders.dropdownValue(this.state.dropdowns[key].value) &&
                                                    <div
                                                        className={Styles.dropdownText}>{this.renders.dropdownValue(this.state.dropdowns[key].value)}</div>
                                                }
                                                {
                                                    !this.renders.dropdownValue(this.state.dropdowns[key].value) &&
                                                    <div
                                                        className={Styles.dropdownText}>{this.state.dropdowns[key].title}</div>
                                                }
                                                {
                                                    this.renders.dropdownValue(this.state.dropdowns[key].value) && false &&
                                                    <img onClick={() => {
                                                        this.state.dropdowns[key].value = '-1';
                                                        this.setState({dropdowns: this.state.dropdowns});
                                                    }} className={Styles.dropdownRemove}
                                                         src={require("../../assets/images/close_icon_white_2.svg")}/>
                                                }
                                                {
                                                    !this.state.dropdowns[key].error &&
                                                    <img className={Styles.dropdownArrow}
                                                         src={require("../../assets/images/arrow-down.svg")}/>
                                                }
                                                {
                                                    this.state.dropdowns[key].error &&
                                                    <img className={Styles.dropdownArrow}
                                                         src={require("../../assets/images/arrow-down-error.svg")}/>
                                                }
                                            </div>
                                        )
                                    })
                                }
                            </div>
                            <div className={Styles.buttonContainer}>
                                <div onClick={() => this.functions.next()} className={cx(Styles.button)}>
                                    {
                                        this.state.error &&
                                        <div className={Styles.buttonError}>
                                            {this.renders.text("item_7")}
                                        </div>
                                    }
                                    {this.renders.text("item_8")}
                                </div>
                                {
                                    <div onClick={() => this.functions.back()} className={Styles.backButton}>
                                        {this.renders.text("item_9")}
                                    </div>
                                }
                            </div>
                        </div>
                    </div>
                }
                {
                    this.state.isLoading &&
                    <div className={Styles.loader}>
                        <BeatLoader size={30} color={'var(--first-color)'} loading={true}/>
                    </div>
                }
            </div>
        );
    }
}

export default BoosterIndustry;


// WEBPACK FOOTER //
// ./src/pages/booster-industry/component.js